import {
  Component,
  HostListener,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SETTINGS } from '../../../../core/config/common.settings';
import { NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { FilesService } from '../../../../core/services/files.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ActionAlert } from '../../../../core/dto/actionAlert';
import { AgentService } from '../../../../core/services/agent.service';
import { CustomerService } from '../../../../core/services/customer.service';
import { FleetService } from '../../../../core/services/fleet.service';
import { AppUtils } from '../../../../core/config/app.utils';
import { DriverService } from '../../../../core/services/driver.service';
import { RentReservationService } from '../../../../core/services/rent-reservation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { IDeactivateComponent } from '../../../../core/guards/deactivate.gaurd';
import { BehaviorSubject, Observable } from 'rxjs';
import { SupplierService } from '../../../../core/services/supplier.service';
import { UserService } from '../../../../core/services/user.service';
import { CurrencyService } from '../../../../core/services/currency.service';
import * as moment from 'moment';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { EmailContentDrawerComponent } from '../../../shared/email-content-drawer/email-content-drawer.component';
import { NzModalService } from 'ng-zorro-antd/modal';

const ADD_EDIT_RENT_BOOKING_LOCAL_LICENSE_UPLOAD =
  'ADD_EDIT_RENT_BOOKING_LOCAL_LICENSE_UPLOAD';
const ADD_EDIT_RENT_BOOKING_SECOND_DRIVER_LOCAL_LICENSE_UPLOAD =
  'ADD_EDIT_RENT_BOOKING_SECOND_DRIVER_LOCAL_LICENSE_UPLOAD';
const ADD_EDIT_RENT_BOOKING_COST_INFO_UPLOAD =
  'ADD_EDIT_RENT_BOOKING_COST_INFO_UPLOAD';

@Component({
  selector: 'app-add-edit-rent-reservation',
  templateUrl: './add-edit-rent-reservation.component.html',
  styleUrls: ['./add-edit-rent-reservation.component.scss'],
})
export class AddEditRentReservationComponent
  implements OnInit, IDeactivateComponent
{
  breadcrumbs: any[] = [];
  rentBookingId: any;
  rentBookingForm: FormGroup | any;
  formErrors: any;
  rentBookingTypeOptions = SETTINGS.RENT_BOOKING_TYPE;
  localDrivingLicenseUploadFiles: any[] = [];
  localDrivingLicenseUploading = false;
  secondDriverLocalDrivingLicenseUploadFiles: any[] = [];
  secondDriverLocalDrivingLicenseUploading = false;
  bookingCostInfoUploadFiles: any[] = [];
  bookingCostInfoUploading = false;
  actionMessage = new ActionAlert();
  agentOptions: any[] = [];
  customerOptions: any[] = [];
  fleetsOptions: any[] = [];
  deductionOptions: any[] = ['Vehicle Breakdown'];
  chargesOptions: any[] = [
    'Local Driving Permit',
    'Baby Seat',
    'GPS',
    'Delivery Fee',
    'Pick Up Fee',
    'Vehicle Upgrade',
    'Driver Charge',
    'Extra Day / Half Day charge due to late departure time',
    'Extra Mileage',
    'Cleaning Charge',
    'Fuel Charge',
    'Damages',
  ];
  driverPromotionDueOptions: any[] = [
    'No International Driving Permit',
    'No Local Driving Permit',
    'Vehicle Unavailability',
  ];
  //add driver popup input
  // canDriveOptions = [
  //   { label: 'Light Vehicles', value: true },
  //   { label: 'Heavy Vehicles', value: true },
  // ];
  vehicleCategories: any;
  currencyOptions: any[] = [];
  visibleAddAgentPopup = false;
  visibleAddCustomerPopup = false;
  visibleAddDriverPopup = false;
  index = 0;
  dIndex = 0;
  driverOptions: any[] = [];
  supplierVehicleOptions: any[] = [];

  depositCurrency: any;
  totalRentalAmountCurrency: any;
  prepaidAmountCurrency: any;
  rentalAmountDueCurrency: any;
  costPerExtraMileageCurrency: any;
  extraChargesCurrencies: any[] = [];
  extraChargesCurrency: any[] = [];
  deductionCurrencies: any[] = [];
  deductionCurrency: any[] = [];
  reservationId: any;
  tempBookingId: any;
  editbleReservation: any;
  subbmit = false;
  totalExtraChargesInLKR = 0;
  totalDeductionsInLKR = 0;
  bookingHandlerOptions: any[] = [];

  // Add vehicle to supplier stuff
  visibleAddVehicleToSupplier = false;
  selectedSupplierId: any;
  selectedSupplierIdOnchange = new BehaviorSubject('');
  selectedOSDriver: any;

  fleetsFetching = false;
  driversFetching = false;
  supplierVehiclesFetching = false;

  loading = false;

  allocatedVehicle = {
    image: 'assets/img/image-placeholder.png',
    registrationNo: '-',
    model: '-',
    mileage: 0,
    fuel: 0,
    seats: 0,
  };
  allocatedDriver = {
    name: '-',
    mobileNo: '-',
    supplier: '-',
  };
  expireMsg = '';
  expireMsgModalOpen = false;
  availabilityStatusPairs = SETTINGS.AVAILABILITY_STATUS_PAIRS;
  driverAvailabilityStatus = SETTINGS.DRIVER_AVAILABILITY_STATUS;

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): string | undefined {
    const confirmationMessage =
      'You have unsaved changes. Do you really want to leave?';
    $event.returnValue = confirmationMessage; // Standard for most browsers
    return confirmationMessage; // For some older browsers
  }

  compareFn = (o1: any, o2: any): boolean =>
    o1 && o2 ? o1._id === o2._id : o1 === o2;
  numberOfDays = 0;
  haveNumberOfDays = true;

  tempBooking: any;
  emailContent = '';

  constructor(
    private fb: FormBuilder,
    private filesService: FilesService,
    private message: NzMessageService,
    private agentService: AgentService,
    private fleetService: FleetService,
    private customerService: CustomerService,
    private driverService: DriverService,
    private supplierService: SupplierService,
    private rentReservationService: RentReservationService,
    private userService: UserService,
    private messages: NzMessageService,
    private route: ActivatedRoute,
    private currencyService: CurrencyService,
    private router: Router,
    private drawerService: NzDrawerService,
    private modal: NzModalService,
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.tempBookingId = params['tempBookingId'];
    });
    this.reservationId = this.route.snapshot.paramMap.get('id');
    this.rentBookingFormInit();
    this.rentBookingFormErrorsInit();
    this.getBookingHandlerOptions();
    this.getAgentOptions();
    this.getDriverOptions();
    this.getCustomerOptions();
    this.getCurrencyOptions();
    this.getVehicleCategory();
    this.getEditableBooking();
    this.getAndSetTempBooking();
    this.uploadLoader();
    this.selectedSupplierIdOnchange.subscribe((res) => {
      this.selectedSupplierId = res;
    });
  }

  setBreadcrumbs(): void {
    if (this.reservationId) {
      this.breadcrumbs = [
        {
          title: 'Rent Booking',
          icon: 'car',
          route: '/admin/booking-rent',
        },
        {
          title: `${this.editbleReservation?.refNo}`,
          route: `/admin/booking-rent/${this.editbleReservation?._id}`,
        },
        {
          title: `Edit`,
        },
      ];
    } else {
      this.breadcrumbs = [
        {
          title: 'Rent Booking',
          icon: 'car',
          route: '/admin/booking-rent',
        },
        {
          title: 'Add',
        },
      ];
    }
  }

  getEditableBooking(): void {
    this.rentBookingForm
      .get('bookingCostInformation')
      .get('extraCharges')
      .clear();
    this.rentBookingForm
      .get('bookingCostInformation')
      .get('deductions')
      .clear();
    if (this.reservationId) {
      this.loading = true;
      this.rentReservationService
        .getReservationById(this.reservationId)
        .subscribe((res: any) => {
          this.editbleReservation = res;
          this.setBreadcrumbs();
          this.emailContent = this.editbleReservation?.emailContentId?.content
            ? this.editbleReservation?.emailContentId?.content
            : '';
          if (
            this.editbleReservation?.bookingCostInformation?.extraCharges
              ?.length > 0
          ) {
            this.editbleReservation?.bookingCostInformation?.extraCharges?.forEach(
              (xc: any) => {
                (
                  this.rentBookingForm
                    .get('bookingCostInformation')
                    .get('extraCharges') as FormArray
                ).push(this.createAExtraCharges());
                if (!this.chargesOptions.includes(xc.chargeType)) {
                  this.addItem({ value: xc.chargeType });
                }
              },
            );

            this.rentBookingForm.patchValue({
              bookingCostInformation: {
                extraCharges:
                  this.editbleReservation?.bookingCostInformation?.extraCharges,
              },
            });
          }

          if (
            this.editbleReservation?.bookingCostInformation?.deductions
              ?.length > 0
          ) {
            this.editbleReservation?.bookingCostInformation?.deductions?.forEach(
              (de: any) => {
                (
                  this.rentBookingForm
                    .get('bookingCostInformation')
                    .get('deductions') as FormArray
                ).push(this.createDeduction());

                if (!this.deductionOptions.includes(de.chargeType)) {
                  this.addDeductionItem({ value: de.chargeType });
                }
              },
            );

            this.rentBookingForm.patchValue({
              bookingCostInformation: {
                deductions:
                  this.editbleReservation?.bookingCostInformation?.deductions,
              },
            });
          }

          if (
            this.editbleReservation?.tourDetails?.arrivalInformation
              ?.arrivalDateAndTime
          ) {
            this.rentBookingForm.patchValue({
              tourDetails: {
                arrivalInformation: {
                  arrivalDate: new Date(
                    this.editbleReservation?.tourDetails?.arrivalInformation
                      ?.arrivalDateAndTime,
                  ),
                  arrivalTime: new Date(
                    this.editbleReservation?.tourDetails?.arrivalInformation
                      ?.arrivalDateAndTime,
                  ),
                },
              },
            });
          }

          if (
            this.editbleReservation?.tourDetails?.departureInformation
              ?.departureDateAndTime
          ) {
            this.rentBookingForm.patchValue({
              tourDetails: {
                departureInformation: {
                  departureDate: new Date(
                    this.editbleReservation?.tourDetails?.departureInformation
                      ?.departureDateAndTime,
                  ),
                  departureTime: new Date(
                    this.editbleReservation?.tourDetails?.departureInformation
                      ?.departureDateAndTime,
                  ),
                },
              },
            });
          }

          if (
            this.editbleReservation?.tourDetails?.actualInformation
              ?.actualStartDateAndTime
          ) {
            this.rentBookingForm.patchValue({
              tourDetails: {
                actualInformation: {
                  actualStartDate: new Date(
                    this.editbleReservation?.tourDetails?.actualInformation
                      ?.actualStartDateAndTime,
                  ),
                  actualStartTime: new Date(
                    this.editbleReservation?.tourDetails?.actualInformation
                      ?.actualStartDateAndTime,
                  ),
                },
              },
            });
          }

          if (
            this.editbleReservation?.tourDetails?.actualInformation
              ?.actualEndDateAndTime
          ) {
            this.rentBookingForm.patchValue({
              tourDetails: {
                actualInformation: {
                  actualEndDate: new Date(
                    this.editbleReservation?.tourDetails?.actualInformation
                      ?.actualEndDateAndTime,
                  ),
                  actualEndTime: new Date(
                    this.editbleReservation?.tourDetails?.actualInformation
                      ?.actualEndDateAndTime,
                  ),
                },
              },
            });
          }

          this.checkAllDynamicValidations();

          this.rentBookingForm.patchValue(this.editbleReservation);

          this.numberOfDays =
            this.editbleReservation?.tourDetails?.numberOfDays;
          this.bookingCostInfoUploadFiles =
            this.editbleReservation?.bookingCostInformation?.attachments;
          this.localDrivingLicenseUploadFiles =
            this.editbleReservation?.customerDetails?.localDrivingLicenseDetails
              ?.attachments;
          this.secondDriverLocalDrivingLicenseUploadFiles =
            this.editbleReservation?.customerDetails?.secondDriverDetails
              ?.localDrivingLicenseDetails?.attachments;
          this.loading = false;
        });
    } else {
      this.setBreadcrumbs();
    }
  }

  getAndSetTempBooking(): void {
    if (this.tempBookingId) {
      this.loading = true;
      this.agentService
        .getAgentTempBookingById(this.tempBookingId)
        .subscribe((res: any) => {
          this.tempBooking = res;
          this.emailContent = this.tempBooking?.content;
          this.rentBookingForm.patchValue({ ...this.tempBooking.booking });
          this.rentBookingForm.patchValue({
            bookingDetails: {
              bookingType: 'THROUGH_AGENT',
            },
          });
          this.rentBookingForm.get('bookingDetails').get('agent').reset();
          this.rentBookingForm.get('customerDetails').get('customer').reset();
          this.rentBookingForm
            .get('tourDetails')
            .get('vehicleCategory')
            .reset();
          this.rentBookingForm
            .get('allocationDetails')
            .get('vehicleCategory')
            .reset();
          this.loading = false;
        });
    }
  }

  rentBookingFormInit() {
    this.rentBookingForm = this.fb.group({
      bookingDetails: this.fb.group({
        bookingReceivedDate: [null, [Validators.required]],
        bookingType: [null, [Validators.required]],
        brokerName: [null],
        bookingReferenceNo: [null],
        agent: [null],
      }),
      customerDetails: this.fb.group({
        customer: [null, [Validators.required]],
        localContactNo: [
          null,
          [
            Validators.compose([
              Validators.required,
              Validators.maxLength(70),
              Validators.pattern(SETTINGS.REGEX.PHONE.EXP),
            ]),
          ],
        ],
        localPermitRequirements: [null, [Validators.required]],
        localAddress: [null, [Validators.required]],
        localDrivingLicenseCheck: [false],
        localDrivingLicenseDetails: this.fb.group({
          localDrivingPermitNumber: [null],
          issuedDate: [null],
          expiryDate: [null],
        }),
        secondDriverCheck: [false],
        secondDriverDetails: this.fb.group({
          driverName: [null],
          localPermitRequirements: [null],
          passportNumber: [null],
          passportIssuedDate: [null],
          passportExpiryDate: [null],
          drivingLicenseNumber: [null],
          drivingLicenseIssuedDate: [null],
          drivingLicenseExpiryDate: [null],
          drivingLicenseIssuedCountry: [null],
          localDrivingLicenseDetails: this.fb.group({
            localDrivingPermitNumber: [null],
            issuedDate: [null],
            expiryDate: [null],
          }),
        }),
      }),
      tourDetails: this.fb.group({
        vehicleCategory: [null, [Validators.required]],
        mileagePreference: [null, [Validators.required]],
        limitedMileage: [null, []], // this validation should be conditional
        numberOfPassengers: [0, [Validators.required]],
        costPerExtraMileage: [null],
        costPerExtraMileageCurrency: ['65961e65cad7ae7c000623ff', []],
        costPerExtraMileageCurrencyDetails: [null, []],
        // numberOfDays: [{value: null, disabled: true}, [Validators.required]],

        arrivalInformation: this.fb.group({
          arrivalDate: [null, [Validators.required]],
          arrivalTime: [null, [Validators.required]],
          arrivalDateAndTime: [null, []],
          arrivalFlightNo: [null,[]],
          pickUpLocation: [null, [Validators.required]],
          arrivalHandler: [null, []],
        }),
        departureInformation: this.fb.group({
          departureDate: [null, [Validators.required]],
          departureTime: [null, [Validators.required]],
          departureDateAndTime: [null, []],
          departureFlightNo: [null, []],
          dropOffLocation: [null, [Validators.required]],
          departureHandler: [null, []],
          dropOffCity: [null, [Validators.required]],
        }),
        actualInformation: this.fb.group({
          actualStartDate: [null, []],
          actualStartTime: [null, []],
          actualStartDateAndTime: [null, []],
          actualEndDate: [null, []],
          actualEndTime: [null, []],
          actualEndDateAndTime: [null, []],
          isExtendedBooking: [null, []],
          noOfDays: [null, []],
        }),
      }),
      allocationDetails: this.fb.group({
        isUpgraded: [false],
        isDowngraded: [false],
        vehicleCategory: [null],
        allocatedVehicle: [null],
        isComplementary: [false],
        reason: [null],
        fuelType: [null, [Validators.required]],
        startFuel: [null, []],
        startMileage: [null, []],
        isDriverPromote: [false],
        driverPromotionDue: [null],
        driverPromotionOtherDue: [null],
        driverCategory: [null],
        isDriverPromotionCompCheck: [false],
        driverPromotionReason: [null],
        allocatedDriver: [null],
        allocatedDriverVehicle: [null],
        outsourcedRate: [null],
        outsourcedRateCurrency: ['65961e65cad7ae7c000623ff', []],
        outsourcedRateCurrencyDetails: [null, []],
      }),
      bookingCostInformation: this.fb.group({
        paymentType: [null, [Validators.required]],
        deposit: [null, [Validators.required]],
        depositCurrency: ['65961e65cad7ae7c000623ff', []],
        depositCurrencyDetails: [null, []],
        totalRentalAmount: [null, [Validators.required]],
        totalRentalAmountCurrency: ['65961e65cad7ae7c000623ff', []],
        totalRentalAmountCurrencyDetails: [null, []],
        prepaidAmount: [null],
        prepaidAmountCurrency: ['65961e65cad7ae7c000623ff', []],
        prepaidAmountCurrencyDetails: [null, []],
        rentalAmountDue: [null, []],
        rentalAmountDueCurrency: ['65961e65cad7ae7c000623ff', []],
        rentalAmountDueCurrencyDetails: [null, []],
        extraCharges: this.fb.array([this.createAExtraCharges()]),
        deductions: this.fb.array([this.createDeduction()]),
      }),
      otherDetails: this.fb.group({
        specialInstruction: [null],
        // userComment: [null],
      }),
    });

    this.rentBookingForm
      .get('tourDetails')
      .get('arrivalInformation')
      .get('arrivalDate')
      .valueChanges.subscribe(() => {
        this.setNumberOfDays();
      });

    this.rentBookingForm
      .get('tourDetails')
      .get('arrivalInformation')
      .get('arrivalTime')
      .valueChanges.subscribe(() => {
        this.setNumberOfDays();
      });

    this.rentBookingForm
      .get('tourDetails')
      .get('departureInformation')
      .get('departureDate')
      .valueChanges.subscribe(() => {
        this.setNumberOfDays();
      });

    this.rentBookingForm
      .get('tourDetails')
      .get('departureInformation')
      .get('departureTime')
      .valueChanges.subscribe(() => {
        this.setNumberOfDays();
      });

    this.rentBookingForm
      .get('bookingCostInformation')
      .valueChanges.subscribe((values: any) => {
        switch (values?.paymentType) {
          case 'PREPAID':
            if (values.totalRentalAmount) {
              this.rentBookingForm
                .get('bookingCostInformation')
                .get('prepaidAmount')
                .setValue(values.totalRentalAmount, {
                  onlySelf: true,
                  emitEvent: false,
                });
            }

            if (values.totalRentalAmountCurrency) {
              const cu = this.currencyOptions?.find(
                (cu: any) => cu._id === values.totalRentalAmountCurrency,
              );
              this.rentBookingForm
                .get('bookingCostInformation')
                .get('totalRentalAmountCurrencyDetails')
                .setValue(cu, {
                  onlySelf: true,
                  emitEvent: false,
                });
              this.rentBookingForm
                .get('bookingCostInformation')
                .get('prepaidAmountCurrency')
                .setValue(values.totalRentalAmountCurrency, {
                  onlySelf: true,
                  emitEvent: false,
                });
              this.rentBookingForm
                .get('bookingCostInformation')
                .get('prepaidAmountCurrencyDetails')
                .setValue(cu, {
                  onlySelf: true,
                  emitEvent: false,
                });
            }

            break;

          case 'ON_ARRIVAL':
            if (values.totalRentalAmount) {
              this.rentBookingForm
                .get('bookingCostInformation')
                .get('rentalAmountDue')
                .setValue(values.totalRentalAmount, {
                  onlySelf: true,
                  emitEvent: false,
                });
            }

            if (values.totalRentalAmountCurrency) {
              const cu = this.currencyOptions?.find(
                (cu: any) => cu._id === values.totalRentalAmountCurrency,
              );
              this.rentBookingForm
                .get('bookingCostInformation')
                .get('totalRentalAmountCurrencyDetails')
                .setValue(cu, {
                  onlySelf: true,
                  emitEvent: false,
                });
              this.rentBookingForm
                .get('bookingCostInformation')
                .get('rentalAmountDueCurrency')
                .setValue(values.totalRentalAmountCurrency, {
                  onlySelf: true,
                  emitEvent: false,
                });
              this.rentBookingForm
                .get('bookingCostInformation')
                .get('rentalAmountDueCurrencyDetails')
                .setValue(cu, {
                  onlySelf: true,
                  emitEvent: false,
                });
            }
            break;

          case 'PART_PREPAID':
            if (
              values.totalRentalAmount &&
              values.totalRentalAmountCurrency &&
              values.prepaidAmount &&
              values.prepaidAmountCurrency
            ) {
              const totalRentalAmountCurrencyDetails =
                this.currencyOptions?.find(
                  (cu: any) => cu._id === values.totalRentalAmountCurrency,
                );
              const prepaidAmountCurrencyDetails = this.currencyOptions?.find(
                (cu: any) => cu._id === values.prepaidAmountCurrency,
              );

              const lkrCurrencyDetails = this.currencyOptions?.find(
                (cu: any) => cu.currencyCode === 'LKR',
              );
              const totalRentalAmountInLKR =
                values.totalRentalAmount *
                totalRentalAmountCurrencyDetails?.lkrRate;
              const prepaidAmountInLKR =
                values.prepaidAmount * prepaidAmountCurrencyDetails?.lkrRate;
              if (totalRentalAmountInLKR < prepaidAmountInLKR) {
                this.messages.create(
                  'info',
                  'Total rental amount less than prepaid amount',
                );
              }
              const rentalAmountDueInLKR =
                totalRentalAmountInLKR - prepaidAmountInLKR;

              this.rentBookingForm
                .get('bookingCostInformation')
                .get('rentalAmountDue')
                .setValue(rentalAmountDueInLKR, {
                  onlySelf: true,
                  emitEvent: false,
                });

              this.rentBookingForm
                .get('bookingCostInformation')
                .get('rentalAmountDueCurrency')
                .setValue(lkrCurrencyDetails?._id, {
                  onlySelf: true,
                  emitEvent: false,
                });

              this.rentBookingForm
                .get('bookingCostInformation')
                .get('rentalAmountDueCurrencyDetails')
                .setValue(lkrCurrencyDetails, {
                  onlySelf: true,
                  emitEvent: false,
                });

              this.rentBookingForm
                .get('bookingCostInformation')
                .get('totalRentalAmountCurrencyDetails')
                .setValue(totalRentalAmountCurrencyDetails, {
                  onlySelf: true,
                  emitEvent: false,
                });
              this.rentBookingForm
                .get('bookingCostInformation')
                .get('prepaidAmountCurrencyDetails')
                .setValue(prepaidAmountCurrencyDetails, {
                  onlySelf: true,
                  emitEvent: false,
                });
            }
            break;

          case 'CREDIT':
            if (
              values.totalRentalAmount &&
              values.totalRentalAmountCurrency &&
              values.prepaidAmount &&
              values.prepaidAmountCurrency
            ) {
              const totalRentalAmountCurrencyDetails =
                this.currencyOptions?.find(
                  (cu: any) => cu._id === values.totalRentalAmountCurrency,
                );
              const prepaidAmountCurrencyDetails = this.currencyOptions?.find(
                (cu: any) => cu._id === values.prepaidAmountCurrency,
              );

              const lkrCurrencyDetails = this.currencyOptions?.find(
                (cu: any) => cu.currencyCode === 'LKR',
              );
              const totalRentalAmountInLKR =
                values.totalRentalAmount *
                totalRentalAmountCurrencyDetails?.lkrRate;
              const prepaidAmountInLKR =
                values.prepaidAmount * prepaidAmountCurrencyDetails?.lkrRate;
              if (totalRentalAmountInLKR < prepaidAmountInLKR) {
                this.messages.create(
                  'info',
                  'Total rental amount less than prepaid amount',
                );
              }
              const rentalAmountDueInLKR =
                totalRentalAmountInLKR - prepaidAmountInLKR;

              this.rentBookingForm
                .get('bookingCostInformation')
                .get('rentalAmountDue')
                .setValue(rentalAmountDueInLKR, {
                  onlySelf: true,
                  emitEvent: false,
                });

              this.rentBookingForm
                .get('bookingCostInformation')
                .get('rentalAmountDueCurrency')
                .setValue(lkrCurrencyDetails?._id, {
                  onlySelf: true,
                  emitEvent: false,
                });

              this.rentBookingForm
                .get('bookingCostInformation')
                .get('rentalAmountDueCurrencyDetails')
                .setValue(lkrCurrencyDetails, {
                  onlySelf: true,
                  emitEvent: false,
                });

              this.rentBookingForm
                .get('bookingCostInformation')
                .get('totalRentalAmountCurrencyDetails')
                .setValue(totalRentalAmountCurrencyDetails, {
                  onlySelf: true,
                  emitEvent: false,
                });
              this.rentBookingForm
                .get('bookingCostInformation')
                .get('prepaidAmountCurrencyDetails')
                .setValue(prepaidAmountCurrencyDetails, {
                  onlySelf: true,
                  emitEvent: false,
                });
            }
            break;

          case 'VOUCHER':
            if (
              values.totalRentalAmount &&
              values.totalRentalAmountCurrency &&
              values.prepaidAmount &&
              values.prepaidAmountCurrency
            ) {
              const totalRentalAmountCurrencyDetails =
                this.currencyOptions?.find(
                  (cu: any) => cu._id === values.totalRentalAmountCurrency,
                );
              const prepaidAmountCurrencyDetails = this.currencyOptions?.find(
                (cu: any) => cu._id === values.prepaidAmountCurrency,
              );

              const lkrCurrencyDetails = this.currencyOptions?.find(
                (cu: any) => cu.currencyCode === 'LKR',
              );
              const totalRentalAmountInLKR =
                values.totalRentalAmount *
                totalRentalAmountCurrencyDetails?.lkrRate;
              const prepaidAmountInLKR =
                values.prepaidAmount * prepaidAmountCurrencyDetails?.lkrRate;
              if (totalRentalAmountInLKR < prepaidAmountInLKR) {
                this.messages.create(
                  'info',
                  'Total rental amount less than prepaid amount',
                );
              }
              const rentalAmountDueInLKR =
                totalRentalAmountInLKR - prepaidAmountInLKR;

              this.rentBookingForm
                .get('bookingCostInformation')
                .get('rentalAmountDue')
                .setValue(rentalAmountDueInLKR, {
                  onlySelf: true,
                  emitEvent: false,
                });

              this.rentBookingForm
                .get('bookingCostInformation')
                .get('rentalAmountDueCurrency')
                .setValue(lkrCurrencyDetails?._id, {
                  onlySelf: true,
                  emitEvent: false,
                });

              this.rentBookingForm
                .get('bookingCostInformation')
                .get('rentalAmountDueCurrencyDetails')
                .setValue(lkrCurrencyDetails, {
                  onlySelf: true,
                  emitEvent: false,
                });

              this.rentBookingForm
                .get('bookingCostInformation')
                .get('totalRentalAmountCurrencyDetails')
                .setValue(totalRentalAmountCurrencyDetails, {
                  onlySelf: true,
                  emitEvent: false,
                });
              this.rentBookingForm
                .get('bookingCostInformation')
                .get('prepaidAmountCurrencyDetails')
                .setValue(prepaidAmountCurrencyDetails, {
                  onlySelf: true,
                  emitEvent: false,
                });
            }
            break;
        }
      });

    this.rentBookingForm
      .get('tourDetails')
      .get('arrivalInformation')
      .valueChanges.subscribe((values: any) => {
        if (values.arrivalDate && values.arrivalTime) {
          let arrivalDateAndTime = new Date(values.arrivalDate);
          const arrivalTime = new Date(values.arrivalTime);
          arrivalDateAndTime = new Date(
            arrivalDateAndTime.setHours(arrivalTime.getHours()),
          );
          arrivalDateAndTime = new Date(
            arrivalDateAndTime.setMinutes(arrivalTime.getMinutes()),
          );
          arrivalDateAndTime = new Date(
            arrivalDateAndTime.setSeconds(arrivalTime.getSeconds()),
          );

          this.rentBookingForm
            .get('tourDetails')
            .get('arrivalInformation')
            .get('arrivalDateAndTime')
            .setValue(arrivalDateAndTime, {
              onlySelf: true,
              emitEvent: false,
            });
          this.rentBookingForm
            .get('tourDetails')
            .get('arrivalInformation')
            .get('arrivalDateAndTime')
            .updateValueAndValidity({
              onlySelf: true,
              emitEvent: false,
            });
        }
      });

    this.rentBookingForm
      .get('tourDetails')
      .get('departureInformation')
      .valueChanges.subscribe((values: any) => {
        if (values.departureDate && values.departureTime) {
          let departureDateAndTime = new Date(values.departureDate);
          const departureTime = new Date(values.departureTime);
          departureDateAndTime = new Date(
            departureDateAndTime.setHours(departureTime.getHours()),
          );
          departureDateAndTime = new Date(
            departureDateAndTime.setMinutes(departureTime.getMinutes()),
          );
          departureDateAndTime = new Date(
            departureDateAndTime.setSeconds(departureTime.getSeconds()),
          );

          this.rentBookingForm
            .get('tourDetails')
            .get('departureInformation')
            .get('departureDateAndTime')
            .setValue(departureDateAndTime, {
              onlySelf: true,
              emitEvent: false,
            });
          this.rentBookingForm
            .get('tourDetails')
            .get('departureInformation')
            .get('departureDateAndTime')
            .updateValueAndValidity({
              onlySelf: true,
              emitEvent: false,
            });
        }
      });

    this.rentBookingForm
      .get('tourDetails')
      .get('actualInformation')
      .valueChanges.subscribe((values: any) => {
        if (values.actualStartDate) {
          this.rentBookingForm
            .get('tourDetails')
            .get('actualInformation')
            .get('actualStartTime')
            .addValidators(Validators.required);
          this.rentBookingForm
            .get('tourDetails')
            .get('actualInformation')
            .get('actualStartTime')
            .updateValueAndValidity({
              onlySelf: true,
              emitEvent: false,
            });
        } else {
          this.rentBookingForm
            .get('tourDetails')
            .get('actualInformation')
            .get('actualStartTime')
            .clearValidators();
          this.rentBookingForm
            .get('tourDetails')
            .get('actualInformation')
            .get('actualStartTime')
            .updateValueAndValidity({
              onlySelf: true,
              emitEvent: false,
            });
        }

        if (values.actualStartTime) {
          this.rentBookingForm
            .get('tourDetails')
            .get('actualInformation')
            .get('actualStartDate')
            .addValidators(Validators.required);
          this.rentBookingForm
            .get('tourDetails')
            .get('actualInformation')
            .get('actualStartDate')
            .updateValueAndValidity({
              onlySelf: true,
              emitEvent: false,
            });
        } else {
          this.rentBookingForm
            .get('tourDetails')
            .get('actualInformation')
            .get('actualStartDate')
            .clearValidators();
          this.rentBookingForm
            .get('tourDetails')
            .get('actualInformation')
            .get('actualStartDate')
            .updateValueAndValidity({
              onlySelf: true,
              emitEvent: false,
            });
        }

        if (values.actualStartDate && values.actualStartTime) {
          let actualStartDateAndTime = new Date(values.actualStartDate);
          const actualStartTime = new Date(values.actualStartTime);
          actualStartDateAndTime = new Date(
            actualStartDateAndTime.setHours(actualStartTime.getHours()),
          );
          actualStartDateAndTime = new Date(
            actualStartDateAndTime.setMinutes(actualStartTime.getMinutes()),
          );
          actualStartDateAndTime = new Date(
            actualStartDateAndTime.setSeconds(actualStartTime.getSeconds()),
          );

          this.rentBookingForm
            .get('tourDetails')
            .get('actualInformation')
            .get('actualStartDateAndTime')
            .setValue(actualStartDateAndTime, {
              onlySelf: true,
              emitEvent: false,
            });
          this.rentBookingForm
            .get('tourDetails')
            .get('actualInformation')
            .get('actualStartDateAndTime')
            .updateValueAndValidity({
              onlySelf: true,
              emitEvent: false,
            });
        }

        if (values.actualEndDate) {
          this.rentBookingForm
            .get('tourDetails')
            .get('actualInformation')
            .get('actualEndTime')
            .addValidators(Validators.required);
          this.rentBookingForm
            .get('tourDetails')
            .get('actualInformation')
            .get('actualEndTime')
            .updateValueAndValidity({
              onlySelf: true,
              emitEvent: false,
            });
        } else {
          this.rentBookingForm
            .get('tourDetails')
            .get('actualInformation')
            .get('actualEndTime')
            .clearValidators();
          this.rentBookingForm
            .get('tourDetails')
            .get('actualInformation')
            .get('actualEndTime')
            .updateValueAndValidity({
              onlySelf: true,
              emitEvent: false,
            });
        }

        if (values.actualEndTime) {
          this.rentBookingForm
            .get('tourDetails')
            .get('actualInformation')
            .get('actualEndDate')
            .addValidators(Validators.required);
          this.rentBookingForm
            .get('tourDetails')
            .get('actualInformation')
            .get('actualEndDate')
            .updateValueAndValidity({
              onlySelf: true,
              emitEvent: false,
            });
        } else {
          this.rentBookingForm
            .get('tourDetails')
            .get('actualInformation')
            .get('actualEndDate')
            .clearValidators();
          this.rentBookingForm
            .get('tourDetails')
            .get('actualInformation')
            .get('actualEndDate')
            .updateValueAndValidity({
              onlySelf: true,
              emitEvent: false,
            });
        }

        if (values.actualEndDate && values.actualEndTime) {
          let actualEndDateAndTime = new Date(values.actualEndDate);
          const actualEndTime = new Date(values.actualEndTime);
          actualEndDateAndTime = new Date(
            actualEndDateAndTime.setHours(actualEndTime.getHours()),
          );
          actualEndDateAndTime = new Date(
            actualEndDateAndTime.setMinutes(actualEndTime.getMinutes()),
          );
          actualEndDateAndTime = new Date(
            actualEndDateAndTime.setSeconds(actualEndTime.getSeconds()),
          );

          this.rentBookingForm
            .get('tourDetails')
            .get('actualInformation')
            .get('actualEndDateAndTime')
            .setValue(actualEndDateAndTime, {
              onlySelf: true,
              emitEvent: false,
            });
          this.rentBookingForm
            .get('tourDetails')
            .get('actualInformation')
            .get('actualEndDateAndTime')
            .updateValueAndValidity({
              onlySelf: true,
              emitEvent: false,
            });
        }
      });

    // Check Passport and license expired
    this.checkPassAndLiceExpired();

    // Fleet options change on tour dates and times changing
    this.fleetOptionChangeOnDateChange();

    this.rentBookingForm.valueChanges.subscribe((values: any) => {
      // Set currency details
      if (values.tourDetails.costPerExtraMileageCurrency) {
        const cu = this.currencyOptions?.find(
          (cu: any) =>
            cu._id === values.tourDetails.costPerExtraMileageCurrency,
        );
        this.rentBookingForm
          .get('tourDetails')
          .get('costPerExtraMileageCurrencyDetails')
          .setValue(cu, {
            onlySelf: true,
            emitEvent: false,
          });
      }

      if (values.allocationDetails.outsourcedRateCurrency) {
        const cu = this.currencyOptions?.find(
          (cu: any) =>
            cu._id === values.allocationDetails.outsourcedRateCurrency,
        );
        this.rentBookingForm
          .get('allocationDetails')
          .get('outsourcedRateCurrencyDetails')
          .setValue(cu, {
            onlySelf: true,
            emitEvent: false,
          });
      }

      if (values.bookingCostInformation.depositCurrency) {
        const cu = this.currencyOptions?.find(
          (cu: any) => cu._id === values.bookingCostInformation.depositCurrency,
        );
        this.rentBookingForm
          .get('bookingCostInformation')
          .get('depositCurrencyDetails')
          .setValue(cu, {
            onlySelf: true,
            emitEvent: false,
          });
      }

      if (values.bookingCostInformation.totalRentalAmountCurrency) {
        const cu = this.currencyOptions?.find(
          (cu: any) =>
            cu._id === values.bookingCostInformation.totalRentalAmountCurrency,
        );
        this.rentBookingForm
          .get('bookingCostInformation')
          .get('totalRentalAmountCurrencyDetails')
          .setValue(cu, {
            onlySelf: true,
            emitEvent: false,
          });
      }

      // if (values.bookingCostInformation.prepaidAmountCurrency) {
      //   const cu = this.currencyOptions?.find(
      //     (cu: any) =>
      //       cu._id === values.bookingCostInformation.prepaidAmountCurrency,
      //   );
      //   this.rentBookingForm
      //     .get('bookingCostInformation')
      //     .get('prepaidAmountCurrencyDetails')
      //     .setValue(cu, {
      //       onlySelf: true,
      //       emitEvent: false,
      //     });
      // }

      if (values.bookingCostInformation.rentalAmountDueCurrency) {
        const cu = this.currencyOptions?.find(
          (cu: any) =>
            cu._id === values.bookingCostInformation.rentalAmountDueCurrency,
        );
        this.rentBookingForm
          .get('bookingCostInformation')
          .get('rentalAmountDueCurrencyDetails')
          .setValue(cu, {
            onlySelf: true,
            emitEvent: false,
          });
      }

      // Set extra charges and deductions totals
      if (values?.bookingCostInformation?.extraCharges?.length > 0) {
        this.totalExtraChargesInLKR = 0;
        values?.bookingCostInformation?.extraCharges?.forEach((ec: any) => {
          if (ec.currency) {
            const cu = this.currencyOptions?.find(
              (cu: any) => cu._id === ec.currency,
            );

            if (ec.amount) {
              this.totalExtraChargesInLKR =
                this.totalExtraChargesInLKR + cu?.lkrRate * ec.amount;
            }
          }
        });
      }

      if (values.bookingCostInformation.deductions.length > 0) {
        this.totalDeductionsInLKR = 0;
        values?.bookingCostInformation?.deductions?.forEach((du: any) => {
          if (du.currency) {
            const cu = this.currencyOptions?.find(
              (cu: any) => cu._id === du.currency,
            );
            if (du.amount) {
              this.totalDeductionsInLKR =
                this.totalDeductionsInLKR + cu.lkrRate * du.amount;
            }
          }
        });
      }

      if (
        values.allocationDetails.isUpgraded ||
        values.allocationDetails.isDowngraded
      ) {
        if (
          values.allocationDetails.isDriverPromote &&
          values.allocationDetails.driverCategory === 'OUTSOURCE_DRIVER'
        ) {
          this.rentBookingForm
            .get('allocationDetails')
            .get('allocatedVehicle')
            .clearValidators();

          this.rentBookingForm
            .get('allocationDetails')
            .get('allocatedVehicle')
            .updateValueAndValidity({ emitEvent: false });
        } else {
          this.rentBookingForm
            .get('allocationDetails')
            .get('allocatedVehicle')
            .addValidators(Validators.required);

          this.rentBookingForm
            .get('allocationDetails')
            .get('allocatedVehicle')
            .updateValueAndValidity({ emitEvent: false });
        }
        this.rentBookingForm
          .get('allocationDetails')
          .get('vehicleCategory')
          .addValidators(Validators.required);

        this.rentBookingForm
          .get('allocationDetails')
          .get('vehicleCategory')
          .updateValueAndValidity({ emitEvent: false });
      } else {
        this.rentBookingForm
          .get('allocationDetails')
          .get('vehicleCategory')
          .clearValidators();

        this.rentBookingForm
          .get('allocationDetails')
          .get('vehicleCategory')
          .updateValueAndValidity({ emitEvent: false });
      }

      if (values.allocationDetails.isComplementary) {
        this.rentBookingForm
          .get('allocationDetails')
          .get('reason')
          .addValidators(Validators.required);
        this.rentBookingForm
          .get('allocationDetails')
          .get('reason')
          .updateValueAndValidity({ emitEvent: false });
      } else {
        this.rentBookingForm
          .get('allocationDetails')
          .get('reason')
          .clearValidators();
        this.rentBookingForm
          .get('allocationDetails')
          .get('reason')
          .updateValueAndValidity({ emitEvent: false });
      }

      if (values.allocationDetails.isDriverPromote) {
        if (values.allocationDetails.isDriverPromotionCompCheck) {
          this.rentBookingForm
            .get('allocationDetails')
            .get('driverPromotionReason')
            .addValidators(Validators.required);
          this.rentBookingForm
            .get('allocationDetails')
            .get('driverPromotionReason')
            .updateValueAndValidity({ emitEvent: false });
        } else {
          this.rentBookingForm
            .get('allocationDetails')
            .get('driverPromotionReason')
            .clearValidators();
          this.rentBookingForm
            .get('allocationDetails')
            .get('driverPromotionReason')
            .updateValueAndValidity({ emitEvent: false });
        }
        this.rentBookingForm
          .get('allocationDetails')
          .get('driverPromotionDue')
          .addValidators(Validators.required);
        this.rentBookingForm
          .get('allocationDetails')
          .get('driverCategory')
          .addValidators(Validators.required);
        this.rentBookingForm
          .get('allocationDetails')
          .get('allocatedDriver')
          .addValidators(Validators.required);
        this.rentBookingForm
          .get('allocationDetails')
          .get('driverPromotionDue')
          .updateValueAndValidity({ emitEvent: false });
        this.rentBookingForm
          .get('allocationDetails')
          .get('driverCategory')
          .updateValueAndValidity({ emitEvent: false });
        this.rentBookingForm
          .get('allocationDetails')
          .get('allocatedDriver')
          .updateValueAndValidity({ emitEvent: false });

        if (values.allocationDetails.driverCategory === 'OUTSOURCE_DRIVER') {
          this.rentBookingForm
            .get('allocationDetails')
            .get('allocatedVehicle')
            .setValue(null, {
              emitEvent: false,
              onlySelf: true,
            });
          this.rentBookingForm
            .get('allocationDetails')
            .get('allocatedDriverVehicle')
            .addValidators(Validators.required);
          this.rentBookingForm
            .get('allocationDetails')
            .get('allocatedDriverVehicle')
            .updateValueAndValidity({ emitEvent: false });
          this.rentBookingForm
            .get('allocationDetails')
            .get('outsourcedRate')
            .addValidators(Validators.required);
          this.rentBookingForm
            .get('allocationDetails')
            .get('outsourcedRate')
            .updateValueAndValidity({ emitEvent: false });
        } else {
          this.rentBookingForm
            .get('allocationDetails')
            .get('allocatedDriverVehicle')
            .clearValidators();
          this.rentBookingForm
            .get('allocationDetails')
            .get('allocatedDriverVehicle')
            .updateValueAndValidity({ emitEvent: false });
          this.rentBookingForm
            .get('allocationDetails')
            .get('outsourcedRate')
            .clearValidators();
          this.rentBookingForm
            .get('allocationDetails')
            .get('outsourcedRate')
            .updateValueAndValidity({ emitEvent: false });
        }
      } else {
        this.rentBookingForm
          .get('allocationDetails')
          .get('driverPromotionDue')
          .clearValidators();
        this.rentBookingForm
          .get('allocationDetails')
          .get('driverPromotionReason')
          .clearValidators();
        this.rentBookingForm
          .get('allocationDetails')
          .get('driverCategory')
          .clearValidators();
        this.rentBookingForm
          .get('allocationDetails')
          .get('allocatedDriver')
          .clearValidators();
        this.rentBookingForm
          .get('allocationDetails')
          .get('allocatedDriverVehicle')
          .clearValidators();
        this.rentBookingForm
          .get('allocationDetails')
          .get('outsourcedRate')
          .clearValidators();
        this.rentBookingForm
          .get('allocationDetails')
          .get('outsourcedRate')
          .updateValueAndValidity({ emitEvent: false });
        this.rentBookingForm
          .get('allocationDetails')
          .get('allocatedDriverVehicle')
          .updateValueAndValidity({ emitEvent: false });
        this.rentBookingForm
          .get('allocationDetails')
          .get('driverPromotionReason')
          .updateValueAndValidity({ emitEvent: false });
        this.rentBookingForm
          .get('allocationDetails')
          .get('driverPromotionDue')
          .updateValueAndValidity({ emitEvent: false });
        this.rentBookingForm
          .get('allocationDetails')
          .get('driverCategory')
          .updateValueAndValidity({ emitEvent: false });
        this.rentBookingForm
          .get('allocationDetails')
          .get('allocatedDriver')
          .updateValueAndValidity({ emitEvent: false });
      }

      if (values?.allocationDetails?.allocatedDriverVehicle) {
        const selectedVehicle = this.supplierVehicleOptions?.find(
          (op: any) =>
            op._id === values?.allocationDetails?.allocatedDriverVehicle,
        );
        this.allocatedVehicle = {
          image: 'assets/img/image-placeholder.png',
          registrationNo: '-',
          model: '-',
          mileage: 0,
          fuel: 0,
          seats: 0,
        };
        this.allocatedVehicle.registrationNo = selectedVehicle?.registerNumber;
        this.allocatedVehicle.model = selectedVehicle?.vehicleModel;
      }

      this.formErrors.bookingDetails = AppUtils.getFormErrors(
        this.rentBookingForm.get('bookingDetails'),
        this.formErrors.bookingDetails,
      );

      this.formErrors.customerDetails = AppUtils.getFormErrors(
        this.rentBookingForm.get('customerDetails'),
        this.formErrors.customerDetails,
      );

      this.formErrors.localDrivingLicenseDetails = AppUtils.getFormErrors(
        this.rentBookingForm
          .get('customerDetails')
          .get('localDrivingLicenseDetails'),
        this.formErrors.localDrivingLicenseDetails,
      );

      this.formErrors.secondDriverDetails = AppUtils.getFormErrors(
        this.rentBookingForm.get('customerDetails').get('secondDriverDetails'),
        this.formErrors.secondDriverDetails,
      );

      this.formErrors.secondDriverDetails.localDrivingLicenseDetails =
        AppUtils.getFormErrors(
          this.rentBookingForm
            .get('customerDetails')
            .get('secondDriverDetails')
            .get('localDrivingLicenseDetails'),
          this.formErrors.secondDriverDetails.localDrivingLicenseDetails,
        );

      //
      this.formErrors.tourDetails = AppUtils.getFormErrors(
        this.rentBookingForm.get('tourDetails'),
        this.formErrors.tourDetails,
      );

      this.formErrors.arrivalInformation = AppUtils.getFormErrors(
        this.rentBookingForm.get('tourDetails').get('arrivalInformation'),
        this.formErrors.arrivalInformation,
      );

      this.formErrors.departureInformation = AppUtils.getFormErrors(
        this.rentBookingForm.get('tourDetails').get('departureInformation'),
        this.formErrors.departureInformation,
      );

      this.formErrors.actualInformation = AppUtils.getFormErrors(
        this.rentBookingForm.get('tourDetails').get('actualInformation'),
        this.formErrors.actualInformation,
      );

      this.formErrors.allocationDetails = AppUtils.getFormErrors(
        this.rentBookingForm.get('allocationDetails'),
        this.formErrors.allocationDetails,
      );

      this.formErrors.bookingCostInformation = AppUtils.getFormErrors(
        this.rentBookingForm.get('bookingCostInformation'),
        this.formErrors.bookingCostInformation,
      );
    });
  }
  fleetOptionChangeOnDateChange() {
    this.rentBookingForm
      .get('tourDetails')
      .get('arrivalInformation')
      .get('arrivalDate')
      .valueChanges.subscribe(() => {
        this.checkFleetOptionChange();
      });
    this.rentBookingForm
      .get('tourDetails')
      .get('arrivalInformation')
      .get('arrivalTime')
      .valueChanges.subscribe(() => {
        this.checkFleetOptionChange();
      });
    this.rentBookingForm
      .get('tourDetails')
      .get('departureInformation')
      .get('departureDate')
      .valueChanges.subscribe(() => {
        this.checkFleetOptionChange();
      });
    this.rentBookingForm
      .get('tourDetails')
      .get('departureInformation')
      .get('departureTime')
      .valueChanges.subscribe(() => {
        this.checkFleetOptionChange();
      });
    this.rentBookingForm
      .get('tourDetails')
      .get('vehicleCategory')
      .valueChanges.subscribe(() => {
        this.checkFleetOptionChange();
      });
  }
  checkFleetOptionChange() {
    if (
      this.rentBookingForm
        .get('tourDetails')
        .get('arrivalInformation')
        .get('arrivalDate').value &&
      this.rentBookingForm
        .get('tourDetails')
        .get('arrivalInformation')
        .get('arrivalTime').value &&
      this.rentBookingForm
        .get('tourDetails')
        .get('departureInformation')
        .get('departureDate').value &&
      this.rentBookingForm
        .get('tourDetails')
        .get('departureInformation')
        .get('departureTime').value &&
      this.rentBookingForm.get('tourDetails').get('vehicleCategory').value
    ) {
      const vehicleCat = this.rentBookingForm
        .get('tourDetails')
        .get('vehicleCategory')
        .getRawValue();
      this.getVehicles(vehicleCat);
    }
  }
  checkPassAndLiceExpired() {
    this.rentBookingForm
      .get('customerDetails')
      .get('customer')
      .valueChanges.subscribe(() => this.passOrLiceExpirePopup());
    this.rentBookingForm
      .get('tourDetails')
      .get('arrivalInformation')
      .get('arrivalDate')
      .valueChanges.subscribe(() => {
        if (
          !this.rentBookingForm
            .get('tourDetails')
            .get('actualInformation')
            .get('actualStartDate').value
        ) {
          this.passOrLiceExpirePopup();
        }
      });
    this.rentBookingForm
      .get('tourDetails')
      .get('actualInformation')
      .get('actualStartDate')
      .valueChanges.subscribe(() => this.passOrLiceExpirePopup());
  }
  passOrLiceExpirePopup(): void {
    const customer = this.customerOptions.find(
      (va: any) =>
        va._id.toString() ===
        this.rentBookingForm
          ?.get('customerDetails')
          ?.get('customer')
          ?.value?.toString(),
    );
    const passExpireDate = customer?.passExpireDate
      ? new Date(customer?.passExpireDate)
      : null;
    const liceExpireDate = customer?.liceExpireDate
      ? new Date(customer?.liceExpireDate)
      : null;
    const tourDate = new Date(
      this.rentBookingForm
        .get('tourDetails')
        .get('actualInformation')
        .get('actualStartDate')
        .getRawValue() ||
        this.rentBookingForm
          .get('tourDetails')
          .get('arrivalInformation')
          .get('arrivalDate')
          .getRawValue() ||
        new Date(),
    );
    if (
      passExpireDate &&
      tourDate > passExpireDate &&
      liceExpireDate &&
      tourDate > liceExpireDate
    ) {
      this.expireMsg = "Selected Customer's Passport and License has expired.";
      this.expireMsgModalOpen = true;
    } else if (passExpireDate && tourDate > passExpireDate) {
      this.expireMsg = "Selected Customer's Passport has expired.";
      this.expireMsgModalOpen = true;
    } else if (liceExpireDate && tourDate > liceExpireDate) {
      this.expireMsg = "Selected Customer's License has expired.";
      this.expireMsgModalOpen = true;
    } else {
      this.expireMsgModalOpen = false;
    }
    if (this.expireMsgModalOpen) {
      this.modal.warning({
        nzTitle: 'Expired warning message',
        nzContent: this.expireMsg,
      });
    }
  }

  rentBookingFormErrorsInit() {
    this.formErrors = {
      bookingDetails: {
        bookingReceivedDate: {},
        bookingType: {},
        brokerName: {},
        bookingReferenceNo: {},
        agent: {},
      },
      customerDetails: {
        customer: {},
        localContactNo: {},
        localPermitRequirements: {},
        localAddress: {},
        localDrivingLicenseCheck: {},
        secondDriverCheck: {},
      },
      secondDriverDetails: {
        driverName: {},
        localPermitRequirements: {},
        passportNumber: {},
        passportIssuedDate: {},
        passportExpiryDate: {},
        drivingLicenseNumber: {},
        drivingLicenseIssuedDate: {},
        drivingLicenseExpiryDate: {},
        drivingLicenseIssuedCountry: {},
        localDrivingLicenseDetails: {
          localDrivingPermitNumber: {},
          issuedDate: {},
          expiryDate: {},
        },
      },
      localDrivingLicenseDetails: {
        localDrivingPermitNumber: {},
        issuedDate: {},
        expiryDate: {},
      },
      tourDetails: {
        vehicleCategory: {},
        mileagePreference: {},
        limitedMileage: {},
        numberOfPassengers: {},
        costPerExtraMileage: {},
        // numberOfDays: {},
      },
      arrivalInformation: {
        arrivalDate: {},
        arrivalTime: {},
        arrivalFlightNo: {},
        pickUpLocation: {},
        arrivalHandler: {},
      },
      departureInformation: {
        departureDate: {},
        departureTime: {},
        departureFlightNo: {},
        dropOffLocation: {},
        dropOffCity: {},
        departureHandler: {},
      },
      actualInformation: {
        actualStartDate: {},
        actualStartTime: {},
        actualEndDate: {},
        actualEndTime: {},
        isExtendedBooking: {},
        noOfDays: {},
      },
      allocationDetails: {
        isUpgraded: {},
        isDowngraded: {},
        vehicleCategory: {},
        allocatedVehicle: {},
        isComplementary: {},
        reason: {},
        fuelType: {},
        startFuel: {},
        startMileage: {},
        isDriverPromote: {},
        driverPromotionDue: {},
        driverPromotionOtherDue: {},
        driverCategory: {},
        isDriverPromotionCompCheck: {},
        driverPromotionReason: {},
        allocatedDriver: {},
        allocatedDriverVehicle: {},
        outsourcedRate: {},
      },
      bookingCostInformation: {
        paymentType: {},
        deposit: {},
        totalRentalAmount: {},
        prepaidAmount: {},
        rentalAmountDue: {},
        extraCharges: {},
        deductions: {},
      },
      otherDetails: {
        specialInstruction: {},
        // userComment: {},
      },
    };
  }

  setNumberOfDays(): void {
    const arrivalDate = this.rentBookingForm
      .get('tourDetails')
      .get('arrivalInformation')
      .get('arrivalDate').value;
    const departureDate = this.rentBookingForm
      .get('tourDetails')
      .get('departureInformation')
      .get('departureDate').value;
    const arrivalTime = this.rentBookingForm
      .get('tourDetails')
      .get('arrivalInformation')
      .get('arrivalTime').value;
    const departureTime = this.rentBookingForm
      .get('tourDetails')
      .get('departureInformation')
      .get('departureTime').value;

    if (arrivalDate && departureDate && arrivalTime && departureTime) {
      this.numberOfDays = 0;
      const startDate = moment(arrivalDate).set({
        hours: moment(arrivalTime).get('hours'),
        minutes: moment(arrivalTime).get('minutes'),
        seconds: moment(arrivalTime).get('seconds'),
      });
      const endDate = moment(departureDate).set({
        hours: moment(departureTime).get('hours'),
        minutes: moment(departureTime).get('minutes'),
        seconds: moment(departureTime).get('seconds'),
      });
      const diffHours = endDate.diff(startDate, 'hours');

      if (diffHours < 0) {
        this.messages.create(
          'info',
          'departure date is less than arrival date',
        );
        this.numberOfDays = 0;
        this.haveNumberOfDays = false;
      } else if (diffHours > 0 && diffHours <= 24) {
        this.numberOfDays = 1;
        this.haveNumberOfDays = true;
      } else if (diffHours > 24) {
        this.numberOfDays = Math.round(diffHours / 24);
        this.haveNumberOfDays = true;
      }
    } else {
      this.numberOfDays = 0;
      this.haveNumberOfDays = true;
    }
  }

  checkValidity(value: boolean): void {
    if (value) {
      this.rentBookingForm
        .get('customerDetails')
        .get('localDrivingLicenseDetails')
        .get('localDrivingPermitNumber')
        .addValidators(Validators.required);
      this.rentBookingForm
        .get('customerDetails')
        .get('localDrivingLicenseDetails')
        .get('issuedDate')
        .addValidators(Validators.required);
      this.rentBookingForm
        .get('customerDetails')
        .get('localDrivingLicenseDetails')
        .get('expiryDate')
        .addValidators(Validators.required);
      this.rentBookingForm
        .get('customerDetails')
        .get('localDrivingLicenseDetails')
        .get('localDrivingPermitNumber')
        .updateValueAndValidity();
      this.rentBookingForm
        .get('customerDetails')
        .get('localDrivingLicenseDetails')
        .get('issuedDate')
        .updateValueAndValidity();
      this.rentBookingForm
        .get('customerDetails')
        .get('localDrivingLicenseDetails')
        .get('expiryDate')
        .updateValueAndValidity();
    } else {
      this.rentBookingForm
        .get('customerDetails')
        .get('localDrivingLicenseDetails')
        .reset();
      this.rentBookingForm
        .get('customerDetails')
        .get('localDrivingLicenseDetails')
        .get('localDrivingPermitNumber')
        .clearValidators();
      this.rentBookingForm
        .get('customerDetails')
        .get('localDrivingLicenseDetails')
        .get('issuedDate')
        .clearValidators();
      this.rentBookingForm
        .get('customerDetails')
        .get('localDrivingLicenseDetails')
        .get('expiryDate')
        .clearValidators();
      this.rentBookingForm
        .get('customerDetails')
        .get('localDrivingLicenseDetails')
        .get('localDrivingPermitNumber')
        .updateValueAndValidity();
      this.rentBookingForm
        .get('customerDetails')
        .get('localDrivingLicenseDetails')
        .get('issuedDate')
        .updateValueAndValidity();
      this.rentBookingForm
        .get('customerDetails')
        .get('localDrivingLicenseDetails')
        .get('expiryDate')
        .updateValueAndValidity();
    }
  }

  checkSecondDriverCheckValue(value: boolean): void {
    if (value) {
      this.rentBookingForm
        .get('customerDetails')
        .get('secondDriverDetails')
        .get('driverName')
        .addValidators(Validators.required);
      this.rentBookingForm
        .get('customerDetails')
        .get('secondDriverDetails')
        .get('localPermitRequirements')
        .addValidators(Validators.required);
      this.rentBookingForm
        .get('customerDetails')
        .get('secondDriverDetails')
        .get('passportNumber')
        .addValidators(Validators.required);
      this.rentBookingForm
        .get('customerDetails')
        .get('secondDriverDetails')
        .get('passportIssuedDate')
        .addValidators(Validators.required);
      this.rentBookingForm
        .get('customerDetails')
        .get('secondDriverDetails')
        .get('passportExpiryDate')
        .addValidators(Validators.required);
      this.rentBookingForm
        .get('customerDetails')
        .get('secondDriverDetails')
        .get('drivingLicenseNumber')
        .addValidators(Validators.required);
      this.rentBookingForm
        .get('customerDetails')
        .get('secondDriverDetails')
        .get('drivingLicenseIssuedDate')
        .addValidators(Validators.required);
      this.rentBookingForm
        .get('customerDetails')
        .get('secondDriverDetails')
        .get('drivingLicenseExpiryDate')
        .addValidators(Validators.required);
      this.rentBookingForm
        .get('customerDetails')
        .get('secondDriverDetails')
        .get('drivingLicenseIssuedCountry')
        .addValidators(Validators.required);

      this.rentBookingForm
        .get('customerDetails')
        .get('secondDriverDetails')
        .get('localDrivingLicenseDetails')
        .get('localDrivingPermitNumber')
        .addValidators(Validators.required);
      this.rentBookingForm
        .get('customerDetails')
        .get('secondDriverDetails')
        .get('localDrivingLicenseDetails')
        .get('issuedDate')
        .addValidators(Validators.required);
      this.rentBookingForm
        .get('customerDetails')
        .get('secondDriverDetails')
        .get('localDrivingLicenseDetails')
        .get('expiryDate')
        .addValidators(Validators.required);

      this.updateSecondDriverDetailsValueAndValidity();
    } else {
      this.rentBookingForm
        .get('customerDetails')
        .get('secondDriverDetails')
        .reset();
      this.rentBookingForm
        .get('customerDetails')
        .get('secondDriverDetails')
        .get('driverName')
        .clearValidators();
      this.rentBookingForm
        .get('customerDetails')
        .get('secondDriverDetails')
        .get('localPermitRequirements')
        .clearValidators();
      this.rentBookingForm
        .get('customerDetails')
        .get('secondDriverDetails')
        .get('passportNumber')
        .clearValidators();
      this.rentBookingForm
        .get('customerDetails')
        .get('secondDriverDetails')
        .get('passportIssuedDate')
        .clearValidators();
      this.rentBookingForm
        .get('customerDetails')
        .get('secondDriverDetails')
        .get('passportExpiryDate')
        .clearValidators();
      this.rentBookingForm
        .get('customerDetails')
        .get('secondDriverDetails')
        .get('drivingLicenseNumber')
        .clearValidators();
      this.rentBookingForm
        .get('customerDetails')
        .get('secondDriverDetails')
        .get('drivingLicenseIssuedDate')
        .clearValidators();
      this.rentBookingForm
        .get('customerDetails')
        .get('secondDriverDetails')
        .get('drivingLicenseExpiryDate')
        .clearValidators();
      this.rentBookingForm
        .get('customerDetails')
        .get('secondDriverDetails')
        .get('drivingLicenseIssuedCountry')
        .clearValidators();

      this.rentBookingForm
        .get('customerDetails')
        .get('secondDriverDetails')
        .get('localDrivingLicenseDetails')
        .get('localDrivingPermitNumber')
        .clearValidators();
      this.rentBookingForm
        .get('customerDetails')
        .get('secondDriverDetails')
        .get('localDrivingLicenseDetails')
        .get('issuedDate')
        .clearValidators();
      this.rentBookingForm
        .get('customerDetails')
        .get('secondDriverDetails')
        .get('localDrivingLicenseDetails')
        .get('expiryDate')
        .clearValidators();

      this.updateSecondDriverDetailsValueAndValidity();
    }
  }

  setBookingCostInputs(value: string): void {
    this.rentBookingForm
      .get('bookingCostInformation')
      .get('totalRentalAmount')
      .reset();
    this.rentBookingForm
      .get('bookingCostInformation')
      .get('totalRentalAmountCurrency')
      .reset();
    this.rentBookingForm
      .get('bookingCostInformation')
      .get('totalRentalAmountCurrencyDetails')
      .reset();
    this.rentBookingForm
      .get('bookingCostInformation')
      .get('prepaidAmount')
      .reset();
    this.rentBookingForm
      .get('bookingCostInformation')
      .get('prepaidAmountCurrency')
      .reset();
    this.rentBookingForm
      .get('bookingCostInformation')
      .get('prepaidAmountCurrencyDetails')
      .reset();
    this.rentBookingForm
      .get('bookingCostInformation')
      .get('rentalAmountDue')
      .reset();
    this.rentBookingForm
      .get('bookingCostInformation')
      .get('rentalAmountDueCurrency')
      .reset();
    this.rentBookingForm
      .get('bookingCostInformation')
      .get('rentalAmountDueCurrencyDetails')
      .reset();
    this.rentBookingForm
      .get('bookingCostInformation')
      .get('prepaidAmount')
      .enable();
    this.rentBookingForm
      .get('bookingCostInformation')
      .get('prepaidAmountCurrency')
      .enable();
    this.rentBookingForm
      .get('bookingCostInformation')
      .get('rentalAmountDue')
      .enable();
    this.rentBookingForm
      .get('bookingCostInformation')
      .get('rentalAmountDueCurrency')
      .enable();
    switch (value) {
      case 'PREPAID':
        this.rentBookingForm
          .get('bookingCostInformation')
          .get('prepaidAmount')
          .disable();
        this.rentBookingForm
          .get('bookingCostInformation')
          .get('prepaidAmountCurrency')
          .disable();
        break;

      case 'ON_ARRIVAL':
        this.rentBookingForm
          .get('bookingCostInformation')
          .get('rentalAmountDue')
          .disable();
        this.rentBookingForm
          .get('bookingCostInformation')
          .get('rentalAmountDueCurrency')
          .disable();
        break;

      case 'PART_PREPAID':
        this.rentBookingForm
          .get('bookingCostInformation')
          .get('rentalAmountDue')
          .disable();
        this.rentBookingForm
          .get('bookingCostInformation')
          .get('rentalAmountDueCurrency')
          .disable();
        break;

      case 'CREDIT':
        this.rentBookingForm
          .get('bookingCostInformation')
          .get('rentalAmountDue')
          .disable();
        this.rentBookingForm
          .get('bookingCostInformation')
          .get('rentalAmountDueCurrency')
          .disable();
        break;

      case 'VOUCHER':
        this.rentBookingForm
          .get('bookingCostInformation')
          .get('rentalAmountDue')
          .disable();
        this.rentBookingForm
          .get('bookingCostInformation')
          .get('rentalAmountDueCurrency')
          .disable();
        break;
    }
  }

  updateSecondDriverDetailsValueAndValidity(): void {
    this.rentBookingForm
      .get('customerDetails')
      .get('secondDriverDetails')
      .get('driverName')
      .updateValueAndValidity();
    this.rentBookingForm
      .get('customerDetails')
      .get('secondDriverDetails')
      .get('localPermitRequirements')
      .updateValueAndValidity();
    this.rentBookingForm
      .get('customerDetails')
      .get('secondDriverDetails')
      .get('passportNumber')
      .updateValueAndValidity();
    this.rentBookingForm
      .get('customerDetails')
      .get('secondDriverDetails')
      .get('passportIssuedDate')
      .updateValueAndValidity();
    this.rentBookingForm
      .get('customerDetails')
      .get('secondDriverDetails')
      .get('passportExpiryDate')
      .updateValueAndValidity();
    this.rentBookingForm
      .get('customerDetails')
      .get('secondDriverDetails')
      .get('drivingLicenseNumber')
      .updateValueAndValidity();
    this.rentBookingForm
      .get('customerDetails')
      .get('secondDriverDetails')
      .get('drivingLicenseIssuedDate')
      .updateValueAndValidity();
    this.rentBookingForm
      .get('customerDetails')
      .get('secondDriverDetails')
      .get('drivingLicenseExpiryDate')
      .updateValueAndValidity();
    this.rentBookingForm
      .get('customerDetails')
      .get('secondDriverDetails')
      .get('drivingLicenseIssuedCountry')
      .updateValueAndValidity();
    this.rentBookingForm
      .get('customerDetails')
      .get('secondDriverDetails')
      .get('localDrivingLicenseDetails')
      .get('localDrivingPermitNumber')
      .updateValueAndValidity();
    this.rentBookingForm
      .get('customerDetails')
      .get('secondDriverDetails')
      .get('localDrivingLicenseDetails')
      .get('issuedDate')
      .updateValueAndValidity();
    this.rentBookingForm
      .get('customerDetails')
      .get('secondDriverDetails')
      .get('localDrivingLicenseDetails')
      .get('expiryDate')
      .updateValueAndValidity();
  }

  checkBookingTypeValidity(value: string): void {
    if (value === 'THROUGH_AGENT') {
      this.rentBookingForm
        .get('bookingDetails')
        .get('bookingReferenceNo')
        .addValidators(Validators.required);
      this.rentBookingForm
        .get('bookingDetails')
        .get('agent')
        .addValidators(Validators.required);
      this.rentBookingForm
        .get('bookingDetails')
        .get('brokerName')
        .addValidators(Validators.required);
      this.rentBookingForm
        .get('bookingDetails')
        .get('bookingReferenceNo')
        .updateValueAndValidity({ emitEvent: false });
      this.rentBookingForm
        .get('bookingDetails')
        .get('agent')
        .updateValueAndValidity({ emitEvent: false });
      this.rentBookingForm
        .get('bookingDetails')
        .get('brokerName')
        .updateValueAndValidity({ emitEvent: false });
    } else {
      this.rentBookingForm
        .get('bookingDetails')
        .get('bookingReferenceNo')
        .reset();
      this.rentBookingForm.get('bookingDetails').get('agent').reset();
      this.rentBookingForm.get('bookingDetails').get('brokerName').reset();
      this.rentBookingForm
        .get('bookingDetails')
        .get('bookingReferenceNo')
        .clearValidators();
      this.rentBookingForm.get('bookingDetails').get('agent').clearValidators();
      this.rentBookingForm
        .get('bookingDetails')
        .get('brokerName')
        .clearValidators();
      this.rentBookingForm
        .get('bookingDetails')
        .get('bookingReferenceNo')
        .updateValueAndValidity({ emitEvent: false });
      this.rentBookingForm
        .get('bookingDetails')
        .get('agent')
        .updateValueAndValidity({ emitEvent: false });
      this.rentBookingForm
        .get('bookingDetails')
        .get('brokerName')
        .updateValueAndValidity({ emitEvent: false });
    }
  }

  checkMileagePreferenceValidity(value: string): void {
    if (value === 'LIMITED') {
      this.rentBookingForm
        .get('tourDetails')
        .get('costPerExtraMileage')
        .addValidators(Validators.required);
      this.rentBookingForm
        .get('tourDetails')
        .get('limitedMileage')
        .addValidators(Validators.required);
      this.rentBookingForm
        .get('tourDetails')
        .get('costPerExtraMileage')
        .updateValueAndValidity({ emitEvent: false });
      this.rentBookingForm
        .get('tourDetails')
        .get('limitedMileage')
        .updateValueAndValidity({ emitEvent: false });
    } else {
      this.rentBookingForm.get('tourDetails').get('limitedMileage').reset();
      this.rentBookingForm
        .get('tourDetails')
        .get('costPerExtraMileage')
        .reset();
      this.rentBookingForm
        .get('tourDetails')
        .get('costPerExtraMileageCurrency')
        .reset();
      this.rentBookingForm
        .get('tourDetails')
        .get('costPerExtraMileage')
        .clearValidators();
      this.rentBookingForm
        .get('tourDetails')
        .get('limitedMileage')
        .clearValidators();
      this.rentBookingForm
        .get('tourDetails')
        .get('costPerExtraMileage')
        .updateValueAndValidity({ emitEvent: false });
      this.rentBookingForm
        .get('tourDetails')
        .get('limitedMileage')
        .updateValueAndValidity({ emitEvent: false });
    }
  }

  checkIsTourExtended(value: boolean) {
    if (value) {
      this.rentBookingForm
        .get('tourDetails')
        .get('actualInformation')
        .get('noOfDays')
        .addValidators(Validators.required);
      this.rentBookingForm
        .get('tourDetails')
        .get('actualInformation')
        .get('noOfDays')
        .updateValueAndValidity();
    } else {
      this.rentBookingForm
        .get('tourDetails')
        .get('actualInformation')
        .get('noOfDays')
        .reset();
      this.rentBookingForm
        .get('tourDetails')
        .get('actualInformation')
        .get('noOfDays')
        .clearValidators();
      this.rentBookingForm
        .get('tourDetails')
        .get('actualInformation')
        .get('noOfDays')
        .updateValueAndValidity();
    }
  }

  updateValueAndValidityRelatedWithDriverCategory(category: string): void {
    switch (category) {
      case 'OUTSOURCE_DRIVER':
        // this.rentBookingForm
        //   .get('allocationDetails')
        //   .controls.allocatedVehicle.setValue(null, {
        //   onlySelf: true,
        //   emitEvent: false,
        // });
        this.rentBookingForm
          .get('allocationDetails')
          .controls['allocatedVehicle'].disable();
        this.rentBookingForm
          .get('allocationDetails')
          .controls['vehicleCategory'].disable();
        this.rentBookingForm
          .get('allocationDetails')
          .controls['fuelType'].disable();
        this.rentBookingForm
          .get('allocationDetails')
          .controls['startFuel'].disable();
        this.rentBookingForm
          .get('allocationDetails')
          .controls['startMileage'].disable();
        this.rentBookingForm
          .get('allocationDetails')
          .controls['fuelType'].reset();
        this.rentBookingForm
          .get('allocationDetails')
          .controls['startFuel'].reset();
        this.rentBookingForm
          .get('allocationDetails')
          .controls['startMileage'].reset();
        this.rentBookingForm
          .get('allocationDetails')
          .controls['fuelType'].clearValidators();
        this.rentBookingForm
          .get('allocationDetails')
          .controls['allocatedVehicle'].clearValidators();
        this.rentBookingForm
          .get('allocationDetails')
          .controls['fuelType'].updateValueAndValidity({ emitEvent: false });
        this.rentBookingForm
          .get('allocationDetails')
          .controls['allocatedVehicle'].updateValueAndValidity({
            emitEvent: false,
          });
        this.rentBookingForm
          .get('allocationDetails')
          .controls['outsourcedRate'].addValidators(Validators.required);
        this.rentBookingForm
          .get('allocationDetails')
          .controls['outsourcedRate'].updateValueAndValidity({
            emitEvent: false,
          });
        break;
      case 'SR_DRIVER':
        this.rentBookingForm
          .get('allocationDetails')
          .controls['allocatedVehicle'].enable();
        this.rentBookingForm
          .get('allocationDetails')
          .controls['vehicleCategory'].enable();
        this.rentBookingForm
          .get('allocationDetails')
          .controls['fuelType'].enable();
        this.rentBookingForm
          .get('allocationDetails')
          .controls['startFuel'].enable();
        this.rentBookingForm
          .get('allocationDetails')
          .controls['startMileage'].enable();
        this.rentBookingForm
          .get('allocationDetails')
          .controls['outsourcedRate'].clearValidators();
        this.rentBookingForm
          .get('allocationDetails')
          .controls['outsourcedRate'].updateValueAndValidity({
            emitEvent: false,
          });
        this.rentBookingForm
          .get('allocationDetails')
          .controls['fuelType'].addValidators(Validators.required);
        this.rentBookingForm
          .get('allocationDetails')
          .controls['allocatedVehicle'].addValidators(Validators.required);
        this.rentBookingForm
          .get('allocationDetails')
          .controls['allocatedVehicle'].updateValueAndValidity({
            emitEvent: false,
          });
        this.rentBookingForm
          .get('allocationDetails')
          .controls['fuelType'].updateValueAndValidity({ emitEvent: false });
        break;
    }
  }

  checkAllDynamicValidations(): void {
    this.checkValidity(
      this.editbleReservation?.customerDetails?.localDrivingLicenseCheck,
    );
    this.checkSecondDriverCheckValue(
      this.editbleReservation?.customerDetails?.secondDriverCheck,
    );
    this.checkBookingTypeValidity(
      this.editbleReservation?.bookingDetails?.bookingType,
    );
    this.checkMileagePreferenceValidity(
      this.editbleReservation?.tourDetails?.mileagePreference,
    );
    this.checkIsTourExtended(
      this.editbleReservation?.tourDetails?.actualInformation
        ?.isExtendedBooking,
    );
    this.getDriverOptions(
      this.editbleReservation?.allocationDetails?.driverCategory,
    );
    this.updateValueAndValidityRelatedWithDriverCategory(
      this.editbleReservation?.allocationDetails?.driverCategory,
    );
    this.checkValue(
      this.editbleReservation?.allocationDetails?.isDriverPromote,
    );

    if (
      this.editbleReservation?.allocationDetails?.isDowngraded ||
      this.editbleReservation?.allocationDetails?.isUpgraded
    ) {
      this.getVehicles(
        this.editbleReservation?.allocationDetails?.vehicleCategory,
      );
    } else {
      this.getVehicles(this.editbleReservation?.tourDetails?.vehicleCategory);
    }

    if (
      (this.editbleReservation?.allocationDetails?.allocatedVehicle &&
        !this.editbleReservation?.allocationDetails?.isDriverPromote) ||
      (this.editbleReservation?.allocationDetails?.isDriverPromote &&
        this.editbleReservation?.allocationDetails?.driverCategory ===
          'SR_DRIVER')
    ) {
      this.getFleetVehicle(
        this.editbleReservation?.allocationDetails?.allocatedVehicle,
      );
    }
    if (
      this.editbleReservation?.allocationDetails?.allocatedDriver &&
      this.editbleReservation?.allocationDetails?.isDriverPromote &&
      this.editbleReservation?.allocationDetails?.driverCategory ===
        'OUTSOURCE_DRIVER'
    ) {
      this.getSupplierVehicles(
        this.editbleReservation?.allocationDetails?.allocatedDriver,
        'edit-initial',
      );
    }

    if (
      this.editbleReservation?.allocationDetails?.allocatedDriver &&
      this.editbleReservation?.allocationDetails?.isDriverPromote
    ) {
      this.getDriver(
        this.editbleReservation?.allocationDetails?.allocatedDriver,
      );
      this.updateValueAndValidityRelatedWithDriverCategory(
        this.editbleReservation?.allocationDetails?.driverCategory,
      );
    }

    if (
      this.editbleReservation?.allocationDetails?.isUpgraded ||
      this.editbleReservation?.allocationDetails?.isDowngraded
    ) {
      this.setValues(
        this.editbleReservation?.allocationDetails?.isUpgraded
          ? this.editbleReservation?.allocationDetails?.isUpgraded
          : this.editbleReservation?.allocationDetails?.isDowngraded,
        this.editbleReservation?.allocationDetails?.isUpgraded
          ? 'upgrade'
          : 'downgrade',
        'edit-initial',
      );
    }
  }

  getAgentOptions(): void {
    this.agentService
      .getAllActiveAgents({ category: 'SR_RENT' })
      .subscribe((res: any) => {
        this.agentOptions = res;
      });
  }

  getBookingHandlerOptions(): void {
    this.userService.getBookingHandlerOptions().subscribe((res: any) => {
      this.bookingHandlerOptions = res;
    });
  }

  getCustomerOptions(): void {
    this.customerService.getAllActiveCustomers().subscribe(
      (res: any) => {
        this.customerOptions = res;
      },
      (e: any) => {
        this.message.create('error', 'Error');
      },
    );
  }

  getCurrencyOptions(): void {
    this.currencyService.getAllActiveCurrencies().subscribe((res: any) => {
      this.currencyOptions = res;
    });
  }

  getSupplierVehicles(event: any, type?: string): void {
    if (type === 'edit-initial') {
      if (event) {
        this.supplierVehiclesFetching = true;
        this.supplierVehicleOptions = [];
        this.driverService
          .getSupplierVehiclesByDriver(event)
          .subscribe((res: any) => {
            this.supplierVehiclesFetching = false;
            this.selectedOSDriver = event;
            this.supplierVehicleOptions = res?.supplierVehicles;
            this.supplierService.supplierVehiclesOnChange.next(
              res?.supplierVehicles,
            );
            this.selectedSupplierIdOnchange.next(res?.supplierId);

            if (
              this.editbleReservation?.allocationDetails?.allocatedDriverVehicle
            ) {
              const selectedVehicle = this.supplierVehicleOptions?.find(
                (op: any) =>
                  op._id ===
                  this.editbleReservation?.allocationDetails
                    ?.allocatedDriverVehicle,
              );
              this.allocatedVehicle = {
                image: 'assets/img/image-placeholder.png',
                registrationNo: '-',
                model: '-',
                mileage: 0,
                fuel: 0,
                seats: 0,
              };
              this.allocatedVehicle.registrationNo =
                selectedVehicle?.registerNumber;
              this.allocatedVehicle.model = selectedVehicle?.vehicleModel;
            }
            // }
          });
      } else {
        this.supplierVehiclesFetching = false;
      }
    } else {
      this.rentBookingForm
        .get('allocationDetails')
        .get('allocatedDriverVehicle')
        .reset();
      if (
        this.rentBookingForm.get('allocationDetails').get('driverCategory')
          .value === 'OUTSOURCE_DRIVER'
      ) {
        if (event) {
          this.supplierVehiclesFetching = true;
          this.supplierVehicleOptions = [];
          this.driverService
            .getSupplierVehiclesByDriver(event)
            .subscribe((res: any) => {
              this.supplierVehiclesFetching = false;
              this.selectedOSDriver = event;
              this.supplierVehicleOptions = res?.supplierVehicles;
              this.supplierService.supplierVehiclesOnChange.next(
                res?.supplierVehicles,
              );
              this.selectedSupplierIdOnchange.next(res?.supplierId);
              // }
            });
        } else {
          this.supplierVehiclesFetching = false;
        }
      }
    }
  }

  getDriverOptions(event?: any): void {
    this.rentBookingForm
      .get('allocationDetails')
      .get('allocatedDriver')
      .reset();
    const payload = {
      driverSegment: event,
      startDate: AppUtils.mergeDateAndTime(
        this.rentBookingForm
          .get('tourDetails')
          .get('arrivalInformation')
          .get('arrivalDate').value,
        this.rentBookingForm
          .get('tourDetails')
          .get('arrivalInformation')
          .get('arrivalTime').value,
      ),
      endDate: AppUtils.mergeDateAndTime(
        this.rentBookingForm
          .get('tourDetails')
          .get('departureInformation')
          .get('departureDate').value,
        this.rentBookingForm
          .get('tourDetails')
          .get('departureInformation')
          .get('departureTime').value,
      ),
      addEditBooking: true,
      ...this.datesAndIdSetForFleetOption(),
    };
    this.driversFetching = true;
    this.driverService.getDriverOptions(payload).subscribe((res: any) => {
      this.driversFetching = false;
      this.driverOptions = res;
    });
    if (
      this.rentBookingForm.get('allocationDetails').get('isDriverPromote')
        .value &&
      event === 'OUTSOURCE_DRIVER'
    ) {
      this.updateValueAndValidityRelatedWithDriverCategory(event);
    } else {
      this.updateValueAndValidityRelatedWithDriverCategory(event);
    }
  }

  async getVehicleCategory(): Promise<void> {
    this.vehicleCategories = await this.fleetService.getAllVehicleCat();
  }

  getVehicles(event: any): void {
    this.fleetsFetching = true;
    this.fleetsOptions = [];
    this.rentBookingForm
      .get('allocationDetails')
      .get('allocatedVehicle')
      .setValue(null, {
        onlySelf: true,
        emitEvent: false,
      });
    if (event !== null) {
      this.fleetService
        .getFleetsAsOptions({
          category: event,
          addEditBooking: true,
          ...this.datesAndIdSetForFleetOption(),
        })
        .then((res: any) => {
          this.fleetsFetching = false;
          this.fleetsOptions = res;
        });
    } else {
      this.fleetsFetching = false;
    }
  }
  datesAndIdSetForFleetOption() {
    const tourStartDate = this.rentBookingForm
      .get('tourDetails')
      .get('arrivalInformation')
      .get('arrivalDateAndTime')
      .getRawValue();
    const tourEndDate = this.rentBookingForm
      .get('tourDetails')
      .get('departureInformation')
      .get('departureDateAndTime')
      .getRawValue();
    if (tourStartDate && tourEndDate) {
      return {
        tourStartDate,
        tourEndDate,
        bookingId: this.reservationId ? this.reservationId : null,
      };
    }
    return {};
  }
  getVehicleAvailabilityIcon(status: string) {
    return this.availabilityStatusPairs.find((st) => st.value === status);
  }
  getDriverAvailabilityIcon(status: string) {
    return this.driverAvailabilityStatus.find((st) => st.value === status);
  }

  setValues(event: any, type: string, occur?: string): void {
    this.fleetsOptions = [];
    if (occur !== 'edit-initial') {
      this.rentBookingForm
        .get('allocationDetails')
        .get('allocatedVehicle')
        .setValue(null, {
          onlySelf: true,
          emitEvent: false,
        });
      this.rentBookingForm
        .get('allocationDetails')
        .get('vehicleCategory')
        .setValue(null, {
          onlySelf: true,
          emitEvent: false,
        });
    }
    if (event) {
      switch (type) {
        case 'downgrade':
          this.rentBookingForm
            .get('allocationDetails')
            .controls.isUpgraded.setValue(false, {
              onlySelf: true,
              // emitEvent: false,
            });
          break;
        case 'upgrade':
          this.rentBookingForm
            .get('allocationDetails')
            .controls.isDowngraded.setValue(false, {
              onlySelf: true,
              // emitEvent: false,
            });
          break;
      }
      this.rentBookingForm
        .get('allocationDetails')
        .get('isComplementary')
        .setValue(null, {
          onlySelf: true,
        });
      this.rentBookingForm.get('allocationDetails').get('reason').reset();
    }

    if (
      !this.rentBookingForm.get('allocationDetails').get('isUpgraded').value &&
      !this.rentBookingForm.get('allocationDetails').get('isDowngraded')
        .value &&
      !event
    ) {
      this.fleetsOptions = [];
      this.rentBookingForm
        .get('allocationDetails')
        .get('allocatedVehicle')
        .addValidators(Validators.required);
      this.rentBookingForm
        .get('allocationDetails')
        .get('allocatedVehicle')
        .updateValueAndValidity({ emitEvent: false });
      if (
        this.rentBookingForm.get('tourDetails').get('vehicleCategory').value
      ) {
        this.fleetService
          .getFleetsAsOptions({
            category: this.rentBookingForm
              .get('tourDetails')
              .get('vehicleCategory').value,
            addEditBooking: true,
            ...this.datesAndIdSetForFleetOption(),
          })
          .then((res: any) => {
            this.fleetsOptions = res;
          });
      }
    }
  }

  checkValue(value: any): void {
    if (!value) {
      this.rentBookingForm
        .get('allocationDetails')
        .get('driverPromotionDue')
        .reset();
      this.rentBookingForm
        .get('allocationDetails')
        .get('driverCategory')
        .reset();
      this.rentBookingForm
        .get('allocationDetails')
        .get('isDriverPromotionCompCheck')
        .reset();
      this.rentBookingForm
        .get('allocationDetails')
        .get('driverPromotionReason')
        .reset();
      this.rentBookingForm
        .get('allocationDetails')
        .get('allocatedDriver')
        .reset();
      this.rentBookingForm
        .get('allocationDetails')
        .get('allocatedDriverVehicle')
        .reset();
      this.rentBookingForm
        .get('allocationDetails')
        .get('outsourcedRate')
        .reset();
      this.rentBookingForm
        .get('allocationDetails')
        .get('outsourcedRateCurrency')
        .reset();
    }
  }

  uploadLoader() {
    this.filesService.fileUploadingSubject.subscribe((res: any) => {
      switch (res.type) {
        case ADD_EDIT_RENT_BOOKING_LOCAL_LICENSE_UPLOAD:
          this.localDrivingLicenseUploading = res.loading;
          break;
        case ADD_EDIT_RENT_BOOKING_SECOND_DRIVER_LOCAL_LICENSE_UPLOAD:
          this.secondDriverLocalDrivingLicenseUploading = res.loading;
          break;
        case ADD_EDIT_RENT_BOOKING_COST_INFO_UPLOAD:
          this.bookingCostInfoUploading = res.loading;
          break;
      }
    });
  }

  localDrivingLicenseUpload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, ADD_EDIT_RENT_BOOKING_LOCAL_LICENSE_UPLOAD)
      .subscribe((res) => {
        this.message.create('success', `Attachment has been uploaded!`);
        const data = res as any;
        this.localDrivingLicenseUploadFiles.push({
          name: item.file.name,
          url: data.url,
        });
        this.filesService.fileUploadingSubject.next({
          type: ADD_EDIT_RENT_BOOKING_LOCAL_LICENSE_UPLOAD,
          loading: false,
        });
      });

  secondDriverLocalDrivingLicenseUpload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(
        item.file,
        ADD_EDIT_RENT_BOOKING_SECOND_DRIVER_LOCAL_LICENSE_UPLOAD,
      )
      .subscribe((res) => {
        this.message.create('success', `Attachment has been uploaded!`);
        const data = res as any;
        this.secondDriverLocalDrivingLicenseUploadFiles.push({
          name: item.file.name,
          url: data.url,
        });
        this.filesService.fileUploadingSubject.next({
          type: ADD_EDIT_RENT_BOOKING_SECOND_DRIVER_LOCAL_LICENSE_UPLOAD,
          loading: false,
        });
      });

  bookingCostInfoUpload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, ADD_EDIT_RENT_BOOKING_COST_INFO_UPLOAD)
      .subscribe((res) => {
        this.message.create('success', `Attachment has been uploaded!`);
        const data = res as any;
        this.bookingCostInfoUploadFiles.push({
          name: item.file.name,
          url: data.url,
        });
        this.filesService.fileUploadingSubject.next({
          type: ADD_EDIT_RENT_BOOKING_COST_INFO_UPLOAD,
          loading: false,
        });
      });

  removeUploadFile(index: any, field: string): void {
    switch (field) {
      case 'local-license':
        this.localDrivingLicenseUploadFiles.splice(index, 1);
        break;
      case 'second-driver-local-license':
        this.secondDriverLocalDrivingLicenseUploadFiles.splice(index, 1);
        break;
      case 'booking-cost-info':
        this.bookingCostInfoUploadFiles.splice(index, 1);
        break;
    }
    this.message.create('success', `Attachment has been deleted!`);
  }

  // extraCharges form array stuff
  createAExtraCharges(): FormGroup {
    return this.fb.group({
      chargeType: ['', []],
      amount: [0, []],
      currency: ['65961e65cad7ae7c000623ff', []],
      currencyDetails: [null, []],
    });
  }

  public get extraCharges(): FormArray {
    return this.rentBookingForm
      .get('bookingCostInformation')
      .get('extraCharges') as FormArray;
  }

  deleteExtraCharges(index: any): void {
    this.extraCharges.removeAt(index);
  }

  addExtraCharge(): void {
    this.extraCharges.push(this.createAExtraCharges());
  }

  // deduction form array stuff
  createDeduction(): FormGroup {
    return this.fb.group({
      chargeType: ['', []],
      amount: [0, []],
      currency: ['65961e65cad7ae7c000623ff', []],
      currencyDetails: [null, []],
    });
  }

  public get deductions(): FormArray {
    return this.rentBookingForm
      .get('bookingCostInformation')
      .get('deductions') as FormArray;
  }

  deleteDeductions(index: any): void {
    this.deductions.removeAt(index);
    this.deductionCurrencies.splice(index, 1);
  }

  addDeduction(): void {
    this.deductions.push(this.createDeduction());
  }

  getFleetVehicle(event: any): void {
    this.allocatedVehicle = {
      image: 'assets/img/image-placeholder.png',
      registrationNo: '-',
      model: '-',
      mileage: 0,
      fuel: 0,
      seats: 0,
    };
    if (event) {
      this.fleetService.getOneFleetById(event).then((res) => {
        if (res.generalInformation?.vehicleImg[0]) {
          this.allocatedVehicle.image = res.generalInformation?.vehicleImg[0];
        }
        this.allocatedVehicle.seats = res.vehicleDetails?.seatsNumber;
        this.allocatedVehicle.registrationNo =
          res.vehicleDetails?.registrationNumber;
      });
    }
  }

  getDriver(event: any) {
    this.allocatedDriver = {
      name: '-',
      mobileNo: '-',
      supplier: '-',
    };
    this.driverService.getOneDriverById(event).then((res) => {
      if (res.supplier) {
        this.selectedSupplierId = res.supplier;
        this.supplierService.getSuppliersById(res.supplier).then((supplier) => {
          this.allocatedDriver.mobileNo = res.mobileNumber;
          this.allocatedDriver.name = res.fullName;
          this.allocatedDriver.supplier = supplier.supplierDetails?.name;
        });
      } else {
        this.allocatedDriver.mobileNo = res.mobileNumber;
        this.allocatedDriver.name = res.fullName;
      }
    });
  }

  submit() {
    const lkr = this.currencyOptions.find(
      (cu: any) => cu.currencyCode === 'LKR',
    );
    let formData = this.rentBookingForm.getRawValue();
    formData.tourDetails = {
      ...formData?.tourDetails,
      numberOfDays: this.numberOfDays,
    };
    formData.tourDetails.costPerExtraMileageCurrency = formData?.tourDetails
      ?.costPerExtraMileageCurrency
      ? formData?.tourDetails?.costPerExtraMileageCurrency
      : lkr?._id;
    formData.tourDetails.costPerExtraMileageCurrencyDetails = formData
      ?.tourDetails?.costPerExtraMileageCurrencyDetails
      ? formData?.tourDetails?.costPerExtraMileageCurrencyDetails
      : lkr;
    formData.bookingCostInformation.depositCurrency = formData
      ?.bookingCostInformation?.depositCurrency
      ? formData?.bookingCostInformation?.depositCurrency
      : lkr?._id;
    formData.bookingCostInformation.depositCurrencyDetails = formData
      ?.bookingCostInformation?.depositCurrencyDetails
      ? formData?.bookingCostInformation?.depositCurrencyDetails
      : lkr;
    formData.bookingCostInformation.totalRentalAmountCurrency = formData
      ?.bookingCostInformation?.totalRentalAmountCurrency
      ? formData?.bookingCostInformation?.totalRentalAmountCurrency
      : lkr?._id;
    formData.bookingCostInformation.totalRentalAmountCurrencyDetails = formData
      ?.bookingCostInformation?.totalRentalAmountCurrencyDetails
      ? formData?.bookingCostInformation?.totalRentalAmountCurrencyDetails
      : lkr;
    formData.bookingCostInformation.prepaidAmountCurrency = formData
      ?.bookingCostInformation?.prepaidAmountCurrency
      ? formData?.bookingCostInformation?.prepaidAmountCurrency
      : lkr?._id;
    formData.bookingCostInformation.prepaidAmountCurrencyDetails = formData
      ?.bookingCostInformation?.prepaidAmountCurrencyDetails
      ? formData?.bookingCostInformation?.prepaidAmountCurrencyDetails
      : lkr;
    formData.bookingCostInformation.rentalAmountDueCurrency = formData
      ?.bookingCostInformation?.rentalAmountDueCurrency
      ? formData?.bookingCostInformation?.rentalAmountDueCurrency
      : lkr?._id;
    formData.bookingCostInformation.rentalAmountDueCurrencyDetails = formData
      ?.bookingCostInformation?.rentalAmountDueCurrencyDetails
      ? formData?.bookingCostInformation?.rentalAmountDueCurrencyDetails
      : lkr;

    if (!formData?.customerDetails?.localDrivingLicenseCheck) {
      delete formData.customerDetails?.localDrivingLicenseDetails;
    } else {
      formData.customerDetails.localDrivingLicenseDetails = {
        ...formData?.customerDetails?.localDrivingLicenseDetails,
        attachments: this.localDrivingLicenseUploadFiles,
      };
    }
    if (!formData?.customerDetails?.secondDriverCheck) {
      delete formData.customerDetails?.secondDriverDetails;
    } else {
      formData.customerDetails.secondDriverDetails.localDrivingLicenseDetails =
        {
          ...formData?.customerDetails?.secondDriverDetails
            ?.localDrivingLicenseDetails,
          attachments: this.secondDriverLocalDrivingLicenseUploadFiles,
        };
    }
    formData.bookingCostInformation = {
      ...formData?.bookingCostInformation,
      attachments: this.bookingCostInfoUploadFiles,
    };

    if (formData?.bookingCostInformation?.extraCharges?.length > 0) {
      this.totalExtraChargesInLKR = 0;
      formData?.bookingCostInformation?.extraCharges?.forEach((ec: any) => {
        if (ec.currency) {
          const cu = this.currencyOptions?.find(
            (cu: any) => cu._id === ec.currency,
          );
          ec.currencyDetails = cu;
        }
      });
    }

    if (formData.bookingCostInformation.deductions.length > 0) {
      this.totalDeductionsInLKR = 0;
      formData?.bookingCostInformation?.deductions?.forEach((du: any) => {
        if (du.currency) {
          const cu = this.currencyOptions?.find(
            (cu: any) => cu._id === du.currency,
          );
          du.currencyDetails = cu;
        }
      });
    }

    if (this.reservationId) {
      formData = {
        ...formData,
        allocationDetails: {
          ...formData.allocationDetails,
          startMileage: this.editbleReservation?.allocationDetails?.startMileage
            ? this.editbleReservation?.allocationDetails?.startMileage
            : null,
          startFuel: this.editbleReservation?.allocationDetails?.startFuel
            ? this.editbleReservation?.allocationDetails?.startFuel
            : null,
          endMileage: this.editbleReservation?.allocationDetails?.endMileage
            ? this.editbleReservation?.allocationDetails?.endMileage
            : null,
          endFuel: this.editbleReservation?.allocationDetails?.endFuel
            ? this.editbleReservation?.allocationDetails?.endFuel
            : null,
          startFuelAndMileageUpdatedAt: this.editbleReservation
            ?.allocationDetails?.startFuelAndMileageUpdatedAt
            ? this.editbleReservation?.allocationDetails
                ?.startFuelAndMileageUpdatedAt
            : null,
          endFuelAndMileageUpdatedAt: this.editbleReservation?.allocationDetails
            ?.endFuelAndMileageUpdatedAt
            ? this.editbleReservation?.allocationDetails
                ?.endFuelAndMileageUpdatedAt
            : null,
        },
      };
      this.rentReservationService
        .updateRentReservation({ _id: this.reservationId, ...formData })
        .subscribe(
          (res: any) => {
            this.subbmit = true;
            this.router.navigate(['admin/booking-rent']);
            this.route.params.subscribe((params) => {
              if (params['pageName'] === 'single-view') {
                this.router.navigate(
                  [`admin/booking-rent/${this.reservationId}`],
                  {},
                );
              } else {
                this.router.navigate(['admin/booking-rent']);
              }
            });
            this.message.create(
              'success',
              'Rent Reservation has been updated!',
            );
          },
          (e: any) => {
            this.message.create('error', 'Error');
          },
        );
    } else {
      this.rentReservationService
        .createRentReservation({
          ...formData,
          tempBooking: this.tempBookingId ? this.tempBookingId : undefined,
        })
        .subscribe(
          (res: any) => {
            this.subbmit = true;
            this.router.navigate(['admin/booking-rent']);
            this.message.create(
              'success',
              'New Rent Reservation has been added!',
            );
          },
          (e: any) => {
            const errorMessage = e.error?.message || 'An error occurred';
            this.message.create('error', errorMessage);
          },
        );
    }
  }

  bookingCancelConfirm() {
    this.rentBookingForm.reset();
    this.localDrivingLicenseUploadFiles = [];
    this.bookingCostInfoUploadFiles = [];
    this.route.params.subscribe((params) => {
      if (params['pageName'] === 'single-view') {
        this.router.navigate([`admin/booking-rent/${this.reservationId}`], {});
      } else {
        this.router.navigate(['admin/booking-rent']);
      }
    });
  }

  bookingCancelNo(): void {}

  onGetAddAgentChange(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.visibleAddAgentPopup = false;
        break;
      case 'created':
        this.message.create('success', 'New Agent has been added!');
        this.getAgentOptions();
        this.visibleAddAgentPopup = false;
        break;
    }
  }

  onGetAddCustomerChange(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.visibleAddCustomerPopup = false;
        break;
      case 'created':
        this.message.create('success', 'New Customer has been added!');
        this.getCustomerOptions();
        this.visibleAddCustomerPopup = false;
        break;
    }
  }

  onGetAddDriverChange(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.visibleAddDriverPopup = false;
        break;
      case 'created':
        this.message.create('success', 'New Driver has been added!');
        this.rentBookingForm
          .get('allocationDetails')
          .get('allocatedDriver')
          .reset();
        this.rentBookingForm
          .get('allocationDetails')
          .get('driverCategory')
          .setValue(event.value, {
            onlySelf: true,
            emitEvent: false,
          });
        this.getDriverOptions(event.value);
        this.visibleAddDriverPopup = false;
        break;
    }
  }

  showAddAgentPopup(): void {
    this.visibleAddAgentPopup = true;
  }

  showAddCustomerPopup(): void {
    this.visibleAddCustomerPopup = true;
  }

  showAddDriverPopup(): void {
    this.driverService.initAddDriverPopupForm.next(true);
    this.visibleAddDriverPopup = true;
  }

  addItem(input: any): void {
    const value = input.value;
    if (this.chargesOptions.indexOf(value) === -1) {
      this.chargesOptions = [
        ...this.chargesOptions,
        input.value || `New item ${this.index++}`,
      ];
    }
  }

  addDriverPromotionDue(input: any): void {
    const value = input.value;
    if (this.driverPromotionDueOptions.indexOf(value) === -1) {
      this.driverPromotionDueOptions = [
        ...this.driverPromotionDueOptions,
        input.value || `New item ${this.index++}`,
      ];
    }
  }

  addDeductionItem(input: any): void {
    const value = input.value;
    if (this.deductionOptions.indexOf(value) === -1) {
      this.deductionOptions = [
        ...this.deductionOptions,
        input.value || `New item ${this.dIndex++}`,
      ];
    }
  }

  canExit(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.subbmit) {
      return true;
    } else if (this.rentBookingForm.dirty || this.rentBookingForm.touched) {
      return confirm(
        ' You have unsaved changes, Do you really want to discard these changes?',
      );
    } else {
      return true;
    }
  }

  // Add vehicle to supplier stuffs
  showAddVehicleToSupplier(): void {
    this.driverService.supplierVehicleFormType.next('add');
    this.visibleAddVehicleToSupplier = true;
  }

  addVehicleOnChange(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.visibleAddVehicleToSupplier = false;
        break;
      case 'submit':
        this.visibleAddVehicleToSupplier = false;
        this.driverService
          .getSupplierVehiclesByDriver(this.selectedOSDriver)
          .subscribe((res: any) => {
            this.supplierVehicleOptions = res?.supplierVehicles;
            // }
          });
        break;
    }
  }
  openEmailContentDrawer(): void {
    if (this.emailContent) {
      const drawerRef = this.drawerService.create({
        nzWidth: '40%',
        nzContent: EmailContentDrawerComponent,
        nzContentParams: {
          content: this.emailContent,
        },
      });
    }
  }
  disableSelectedVehicle(vehicleId: string) {
    return this.editbleReservation?.allocationDetails?.allocatedVehicle &&
      this.rentBookingForm?.get('allocationDetails')?.get('allocatedVehicle')
        ?.value
      ? this.editbleReservation.allocationDetails.allocatedVehicle.toString() ===
          vehicleId.toString()
      : false;
  }

  refreshVehicles() {
    const bookingType = this.rentBookingForm.get('bookingDetails.bookingType').value;
    const vehicleCategory = this.rentBookingForm.get('tourDetails.vehicleCategory').value;
    const allocatedVehicleCategory = this.rentBookingForm.get('allocationDetails.vehicleCategory').value;
  
    console.log('Refresh Vehicles - Booking Type:', bookingType);
    console.log('Vehicle Category:', vehicleCategory);
    console.log('Allocated Vehicle Category:', allocatedVehicleCategory);
  
    // Reset vehicle options
    this.supplierVehicleOptions = [];
  
    // Fetch vehicles based on vehicle category
    if (vehicleCategory || allocatedVehicleCategory) {
      this.getVehicles(vehicleCategory);
    } else {
      console.log('No vehicle category selected');
      this.messages.create('warning', 'Please select a vehicle category');
    }
  }
  

  refreshDrivers() {
    // Get the current driver category
    const driverCategory = this.rentBookingForm
      .get('allocationDetails.driverCategory')
      .value;
  
    // Reset the allocated driver
    this.rentBookingForm
      .get('allocationDetails.allocatedDriver')
      .setValue(null);
  
    // Set fetching flag
    this.driversFetching = true;
  
    // Call getDriverOptions method
    this.getDriverOptions(driverCategory);
  }
  
  
}
